{
  "account.account": "Profil ve güvenlik",
  "account.accountDeleted": "Hesabınız başarıyla silindi.",
  "account.accountDescription": "Ad, şifre, hesabı silme",
  "account.accountSection": "Hesap",
  "account.changeEmail": "E-postayı değiştir",
  "account.changePassword": "Şifre değiştir",
  "account.currentPassword": "Mevcut şifre",
  "account.dangerZone": "Riskli bölge",
  "account.deleteAccount": "Hesabınızı silin",
  "account.deleteAccountConfirmation": "Hesabınızı silmek istediğinizden emin misiniz? Bu eylem geri döndürülemez.",
  "account.deleteAccountDescription": "Bu eylem hesabınızı ve tüm bilgilerinizi siler. Geri dönüş yok.",
  "account.emailChange": "E-posta adresini değiştir",
  "account.emailChangeConfirmation": "E-posta değişikliği onayı",
  "account.emailChangeFailure": "E-posta değişiklik bağlantısı geçersiz veya süresi dolmuş.",
  "account.emailChangeIntro": "Yeni e-posta adresinizi ve mevcut şifrenizi girin. Yeni adrese bir bağlantı göndereceğiz: e-posta adresiniz ancak bu bağlantıyı açtığınızda değişir.",
  "account.emailChangeSuccess": "E-postanız başarıyla {newEmail} olarak değiştirildi.",
  "account.emailChangeSuccessNoAddress": "E-posta adresiniz başarıyla değiştirildi.",
  "account.emailChangeVerificationSent": "Yeni e-posta adresinize bir doğrulama e-postası gönderildi. Lütfen gelen kutunuzu kontrol edin ve değişikliği onaylamak için bağlantıya tıklayın.",
  "account.manageAccount": "Hesabı Yönetin",
  "account.newEmailAddress": "Yeni e-posta adresi",
  "account.newPassword": "Yeni Şifre",
  "account.newPasswordAgain": "Yeni şifre (tekrar)",
  "account.oldPassword": "Eski Şifre",
  "account.passwordChange": "Şifre Değişikliği",
  "account.passwordChangeDescription": "Hesabınızı güvende tutun",
  "account.passwordUpdated": "Şifre başarıyla güncellendi.",
  "account.profile": "Profil",
  "account.profileUpdated": "Profil başarıyla güncellendi.",
  "account.signedInAs": "Şu hesapla oturum açıldı",
  "account.updateYourProfile": "Profilinizi güncelleyin",
  "account.updateYourProfileDescription": "Ad ve görüntüleme tercihleri",
  "addons.accountOnHold": "Hesap bağlantınızın süresi doldu. Veri güncellemelerini sürdürmek için lütfen yeniden bağlanın.",
  "addons.accountOnHoldTitle": "Hesap beklemede",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Bu bağlantıdan API anahtarınızı oluşturun ve alın",
  "addons.ambientWeatherDescription": "Ambient Weather hava istasyonları (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API Anahtarı",
  "addons.applicationKey": "Uygulama anahtarı",
  "addons.availableServices": "Mevcut",
  "addons.cannotDisconnectLastAccount": "Tek giriş yönteminizin bağlantısı kesilemez. Lütfen önce başka bir giriş yöntemi ekleyin.",
  "addons.connect": "Bağla",
  "addons.connected": "Bağlı",
  "addons.connectedAccounts": "Bağlı hesaplar",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "Bağlı hesaplarınız yükleniyor…",
  "addons.connectedServices": "Bağlı",
  "addons.connectedSince": "{date} tarihinden beri bağlı",
  "addons.connectionSection": "Bağlantı",
  "addons.connectionSuccess": "{provider} hesabı başarıyla bağlandı",
  "addons.davisApiSecret": "API sırrı",
  "addons.davisApiV2Key": "V2 API Anahtarı",
  "addons.davisDescription": "Davis Hava Durumu İstasyonları (Vantage Vue, Vantage Pro2, ...)",
  "addons.davisRetrieveApiKey": "V2 API anahtarlarınızı bu bağlantıdan alın",
  "addons.disconnect": "Bağlantıyı kes",
  "addons.disconnectConfirmation": "{provider} hesabınızın bağlantısını kesmek istediğinizden emin misiniz?",
  "addons.disconnectEnergyConfirmation": "SmartMixin, Netatmo Energy eşitlemesini durdurur ve evlerinizi SmartMixin'den kaldırır. Netatmo hesabınız ve cihazlarınız bundan etkilenmez.",
  "addons.disconnectEnergyDescription": "Eşitlemeyi durdurur ve evlerinizi SmartMixin'den kaldırır.",
  "addons.disconnectionSuccess": "{provider} hesabının bağlantısı başarıyla kesildi",
  "addons.disconnectProviderDescription": "Eşitlemeyi durdurur ve bu hizmetin istasyonlarını geçmişleriyle birlikte siler.",
  "addons.disconnectServiceConfirmation": "SmartMixin, {provider} eşitlemesini durdurur ve bu hizmetin istasyonlarını tüm geçmişleriyle birlikte siler. {provider} hesabınızın kendisi bundan etkilenmez.",
  "addons.disconnectServiceTitle": "{provider} bağlantısı kesilsin mi?",
  "addons.ecowittCreateAndRetrieveKeys": "Bu bağlantıdan hem API anahtarı hem de bir uygulama anahtarı oluşturun ve alın",
  "addons.ecowittDescription": "Ecowitt, profesyonel WiFi hava durumu istasyonu, kablosuz iç ve dış mekan termometreleri, nem monitörleri, yüksek hassasiyetli yağmur göstergeleri, hava kalitesi monitörleri ve daha fazlasını sağlar.",
  "addons.helpLink": "{provider} nasıl bağlanır",
  "addons.integrationsSection": "Entegrasyonlar",
  "addons.myAcuriteAccountOnHold": "Hesabınız beklemeye alındı. Hesabınızı yeniden bağlamak için lütfen şifrenizi girin",
  "addons.myAcuriteDescription": "AcuRite, Kuzey Amerika'nın 1 numaralı hava istasyonu markasıdır. Zaman, sıcaklık ve hava durumu teknolojisinde lider olan AcuRite, iç ve dış ortamınız hakkında ayrıntılı bilgi sunar; böylece gününüzü güvenle planlayabilirsiniz.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Evinizin sıcaklığını yatağınızdan ya da dünyanın öbür ucundan değiştirmek için Netatmo termostatınızı kullanın.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Evde kişisel hava istasyonunuz",
  "addons.notConnected": "Bağlı değil",
  "addons.or": "veya",
  "addons.providerAccountDisconnected": "Hava durumu hizmetinize olan bağlantı süresi doldu. Veri güncellemelerini sürdürmek için lütfen yeniden bağlanın.",
  "addons.reconnect": "Yeniden bağlan",
  "addons.socialConnectionsIntro": "Hızlı giriş için sosyal hesaplarınızı bağlayın. Hesapları istediğiniz zaman bağlayabilir veya bağlantısını kesebilirsiniz.",
  "addons.weatherflowAccessToken": "Erişim belirteci",
  "addons.weatherflowCreateToken": "Bu bağlantıdan jetonunuzu oluşturun ve alın",
  "addons.weatherflowTempestDescription": "Dahili rüzgâr ölçer ve yağmur ölçerli Tempest hava sistemi",
  "addons.weatherServices": "Hava durumu servisleri",
  "addons.weatherServicesConnected": "{count, plural, =0 {Bağlı hizmet yok} one {# hizmet bağlı} other {# hizmet bağlı}}",
  "addons.weatherServicesDescription": "Netatmo, Davis, Weatherflow ve diğerlerini bağlayın",
  "addons.wundergroundApiKey": "API Anahtarı",
  "addons.wundergroundDescription": "Weather Underground, hava istasyonları ve hava kalitesi monitörleri gibi çevre sensörlerinden veri birleştiren küresel bir insan topluluğudur, böylece tutkularınızı güçlendirmek için ihtiyacınız olan zengin, hiperlokal verileri sağlayabiliriz",
  "addons.wundergroundRemoveStationDescription": "İstasyon SmartMixin hesabınızdan çıkarılır. Başka bir SmartMixin hesabı da eklemediyse, istasyon ve SmartMixin'in onun için kaydettiği geçmiş silinir. Weather Underground'da hiçbir şey değişmez.",
  "addons.wundergroundRemoveStationTitle": "{station} silinsin mi?",
  "addons.wundergroundRetrieveApiKey": "API anahtarınızı bu bağlantıdan alın",
  "addons.wundergroundStationId": "İstasyon kimliği",
  "airQuality.adviceActivityGood": "Dışarıda aktif olmak için ideal bir gün",
  "airQuality.adviceActivityHazardous": "Dışarıda her türlü fiziksel aktiviteden kaçının",
  "airQuality.adviceActivityLabel": "Fiziksel aktivite",
  "airQuality.adviceActivityModerate": "Dışarıda aktif olmak için iyi bir gün",
  "airQuality.adviceActivitySensitive": "Dış mekân aktivitelerini daha kısa ve daha az yoğun tutmayı düşünün",
  "airQuality.adviceActivityUnhealthy": "Uzun veya yoğun aktiviteleri azaltın ve daha sık ara verin",
  "airQuality.adviceActivityVeryUnhealthy": "Uzun veya yoğun aktivitelerden kaçının; bunları iç mekâna taşımayı düşünün",
  "airQuality.adviceGroupsGood": "Özel bir önlem gerekmiyor",
  "airQuality.adviceGroupsHazardous": "İç mekânda kalın ve aktiviteyi düşük tutun",
  "airQuality.adviceGroupsLabel": "Hassas gruplar",
  "airQuality.adviceGroupsModerate": "Özellikle hassas kişiler: aktiviteleri daha kısa ve daha az yoğun tutun",
  "airQuality.adviceGroupsSensitive": "Dış mekân aktivitelerini daha kısa ve daha az yoğun tutun, daha sık ara verin",
  "airQuality.adviceGroupsUnhealthy": "Uzun veya yoğun dış mekân aktivitelerinden kaçının; bunları iç mekâna taşımayı düşünün",
  "airQuality.adviceGroupsVeryUnhealthy": "Dışarıda her türlü fiziksel aktiviteden kaçının; erteleyin veya iç mekâna taşıyın",
  "airQuality.adviceTimingLabel": "Ne zaman dışarı çıkmalı",
  "airQuality.adviceTimingMorning": "Tercihen sabah — ozon o saatlerde daha düşük",
  "airQuality.airQuality": "Hava kalitesi",
  "airQuality.airQualityIndex": "Hava Kalitesi Endeksi",
  "airQuality.aqiForecast": "Hava kalitesi tahmini",
  "airQuality.co2Fresh": "Temiz",
  "airQuality.co2GettingStale": "Biraz ağır",
  "airQuality.co2Stale": "Ağır",
  "airQuality.dailyForecast": "Günlük Tahmin",
  "airQuality.dominantPollutant": "Baskın kirletici",
  "airQuality.expectedPeak": "Beklenen zirve",
  "airQuality.good": "İyi",
  "airQuality.goodDescription": "Hava kalitesi tatmin edici olarak kabul edilir ve hava kirliliği çok az risk oluşturur veya hiç yoktur",
  "airQuality.hazardous": "Tehlikeli",
  "airQuality.hazardousDescription": "Sağlık Uyarısı: Herkes daha ciddi sağlık etkileri yaşayabilir",
  "airQuality.indoorAirQuality": "İç mekan hava kalitesi",
  "airQuality.moderate": "Orta",
  "airQuality.moderateDescription": "Hava kalitesi kabul edilebilir; Bununla birlikte, bazı kirleticiler için, hava kirliliğine alışılmadık derecede duyarlı olan çok az sayıda insan için ılımlı bir sağlık sorunu olabilir.",
  "airQuality.noForecastForLocation": "Bu konum için hava kalitesi tahmini mevcut değil.",
  "airQuality.now": "Şimdi",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Kirleticiler",
  "airQuality.recommendations": "Öneriler",
  "airQuality.sensitiveUnhealthy": "Hassas gruplar için sağlıksız",
  "airQuality.sensitiveUnhealthyDescription": "Hassas grupların üyeleri sağlık etkileri yaşayabilir. Genel halkın etkilenmesi muhtemel değildir.",
  "airQuality.subIndex": "AQI alt indeksi",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Endeksi anlamak",
  "airQuality.unhealthy": "Sağlıksız",
  "airQuality.unhealthyDescription": "Herkes sağlık etkileri yaşamaya başlayabilir; Hassas grupların üyeleri daha ciddi sağlık etkileri yaşayabilir",
  "airQuality.veryUnhealthy": "Çok sağlıksız",
  "airQuality.veryUnhealthyDescription": "Acil durum koşullarının sağlık uyarıları. Tüm nüfusun etkilenmesi daha olasıdır.",
  "alerts.addAlert": "Uyarı Ekle",
  "alerts.addCondition": "Koşul ekle",
  "alerts.alertAdded": "Uyarı başarıyla eklendi",
  "alerts.alertAuthorizationNotice": "Uyarılar yalnızca SmartMixin'e bildirimleri görüntüleme yetkisi verirseniz çalışır",
  "alerts.alertDeleted": "Uyarı başarıyla silindi",
  "alerts.alertName": "Uyarı Adı",
  "alerts.alertWhen": "Şu durumda uyarılmak istiyorum:",
  "alerts.aqiGreaterThan": "AQI daha büyük",
  "alerts.aqiGreaterThanThreshold": "AQI {value}{unit} eşiğinden daha büyük",
  "alerts.aqiLessThan": "AQI daha az",
  "alerts.aqiLessThanThreshold": "AQI {value}{unit} eşiğinden daha az",
  "alerts.atLeastOneCondition": "En az bir koşul eklemeniz gerekiyor",
  "alerts.co2GreaterThan": "CO2 daha büyük",
  "alerts.co2GreaterThanThreshold": "CO2 {value}{unit} eşiğinden daha büyük",
  "alerts.co2LessThan": "CO2 daha az",
  "alerts.co2LessThanThreshold": "CO2 {value}{unit} eşiğinden daha az",
  "alerts.conditions": "Koşullar",
  "alerts.conditionsDroppedOnStationChange": "Bu istasyon desteklemiyor, kaldırıldı: {conditions}",
  "alerts.createAlert": "Uyarı Oluştur",
  "alerts.dailyPrecipitationGreaterThan": "Günlük yağış şundan fazla",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Günlük yağış {value}{unit} eşiğini aştı",
  "alerts.deleteAlert": "Uyarıyı sil",
  "alerts.editAlert": "Uyarı düzenle",
  "alerts.editCondition": "Koşulu düzenle",
  "alerts.gustSpeedGreaterThan": "Rüzgâr hamlesi hızı daha büyük",
  "alerts.gustSpeedGreaterThanThreshold": "Rüzgâr hamlesi hızı {value}{unit} eşiğinden daha büyük",
  "alerts.gustSpeedLessThan": "Rüzgâr hamlesi hızı daha az",
  "alerts.gustSpeedLessThanThreshold": "Rüzgâr hamlesi hızı {value}{unit} eşiğinden daha az",
  "alerts.heatIndexGreaterThan": "Isı indeksi daha büyük",
  "alerts.heatIndexGreaterThanThreshold": "{value}{unit} eşiğinden büyük ısı indeksi",
  "alerts.heatIndexLessThan": "Isı indeksi daha az",
  "alerts.heatIndexLessThanThreshold": "{value}{unit} eşiğinden daha az ısı indeksi",
  "alerts.humidexGreaterThan": "Humidex daha büyük",
  "alerts.humidexGreaterThanThreshold": "{value}{unit} eşiğinden büyük Humidex",
  "alerts.humidexLessThan": "Humidex daha az",
  "alerts.humidexLessThanThreshold": "{value}{unit} eşiğinden daha az Humidex",
  "alerts.humidityGreaterThan": "Nem daha büyük",
  "alerts.humidityGreaterThanThreshold": "Nem {value}{unit} eşiğinden daha büyük",
  "alerts.humidityLessThan": "Nem daha az",
  "alerts.humidityLessThanThreshold": "Nem {value}{unit} eşiğinden daha az",
  "alerts.inProgress": "Devam etmekte",
  "alerts.leafWetnessGreaterThan": "Yaprak ıslaklığı daha yüksek",
  "alerts.leafWetnessGreaterThanThreshold": "Yaprak ıslaklığı {value}{unit} eşiğinden daha yüksek",
  "alerts.leafWetnessLessThan": "Yaprak ıslaklığı daha düşük",
  "alerts.leafWetnessLessThanThreshold": "Yaprak ıslaklığı {value}{unit} eşiğinden daha düşük",
  "alerts.myAlerts": "Uyarılarım",
  "alerts.noConfiguredAlert": "Henüz yapılandırılmış herhangi bir uyarınız yok, bir tane eklemeye başlayın",
  "alerts.noiseGreaterThan": "Gürültü daha büyük",
  "alerts.noiseGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük gürültü",
  "alerts.noiseLessThan": "Gürültü daha az",
  "alerts.noiseLessThanThreshold": "{value}{unit} eşiğinden daha az gürültü",
  "alerts.noteOnConditions": "Aşağıdaki koşulların tümü doğrulandığında uyarının tetiklendiğini unutmayın",
  "alerts.noTriggerHistory": "Bu uyarı henüz tetiklenmedi.",
  "alerts.pm10GreaterThan": "PM 10 daha büyük",
  "alerts.pm10GreaterThanThreshold": "PM 10 {value}{unit} eşiğinden daha büyük",
  "alerts.pm10LessThan": "PM 10 daha az",
  "alerts.pm10LessThanThreshold": "PM 10 {value}{unit} eşiğinden daha az",
  "alerts.pm1GreaterThan": "PM 1 daha büyük",
  "alerts.pm1GreaterThanThreshold": "PM 1 {value}{unit} eşiğinden daha büyük",
  "alerts.pm1LessThan": "PM 1 daha az",
  "alerts.pm1LessThanThreshold": "PM 1 {value}{unit} eşiğinden daha az",
  "alerts.pm2p5GreaterThan": "PM 2.5 daha büyük",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 {value}{unit} eşiğinden daha büyük",
  "alerts.pm2p5LessThan": "PM 2.5 daha az",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 {value}{unit} eşiğinden daha az",
  "alerts.postStormSummary": "Yağış sonrası özeti",
  "alerts.postStormSynopsisHelper": "Her yağış sona erdiğinde özet bildirimi alırsınız.",
  "alerts.postStormSynopsisSoleCondition": "Yağış sonrası özeti diğer koşullarla birleştirilemez.",
  "alerts.precipitationGreaterThan": "Saatlik yağış şundan fazla",
  "alerts.precipitationGreaterThanThreshold": "Saatlik yağış {value}{unit} eşiğini aştı",
  "alerts.pressureGreaterThan": "Basınç daha büyük",
  "alerts.pressureGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük basınç",
  "alerts.pressureLessThan": "Basınç daha az",
  "alerts.pressureLessThanThreshold": "{value}{unit} eşiğinden daha az basınç",
  "alerts.rainRateGreaterThan": "Yağış yoğunluğu şundan fazla",
  "alerts.rainRateGreaterThanThreshold": "Yağış yoğunluğu {value}{unit} eşiğini aştı",
  "alerts.sensorNotReporting": "Bu sensör şu anda veri göndermiyor. Uyarı, sensör yeniden veri gönderdiğinde devam eder.",
  "alerts.soilMoistureGreaterThan": "Toprak nemi daha yüksek",
  "alerts.soilMoistureGreaterThanThreshold": "Toprak nemi {value}{unit} eşiğinden daha yüksek",
  "alerts.soilMoistureLessThan": "Toprak nemi daha düşük",
  "alerts.soilMoistureLessThanThreshold": "Toprak nemi {value}{unit} eşiğinden daha düşük",
  "alerts.solarRadiationGreaterThan": "Güneş radyasyonu daha büyük",
  "alerts.solarRadiationGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük güneş radyasyonu",
  "alerts.solarRadiationLessThan": "Güneş radyasyonu daha az",
  "alerts.solarRadiationLessThanThreshold": "{value}{unit} eşiğinden daha az güneş radyasyonu",
  "alerts.stationNoLongerReports": "Bu istasyon artık veri göndermiyor, bu nedenle bu uyarı tetiklenemez.",
  "alerts.stormChartUnavailable": "Bu yağış için yağmur geçmişi mevcut değil.",
  "alerts.stormDetail": "Yağış özeti",
  "alerts.stormDuration": "Süre",
  "alerts.stormEnd": "Bitiş",
  "alerts.stormPeakRate": "En yüksek yağış şiddeti",
  "alerts.stormStart": "Başlangıç",
  "alerts.stormTotal": "Toplam yağış",
  "alerts.temperatureGreaterThan": "Sıcaklık daha büyük",
  "alerts.temperatureGreaterThanThreshold": "{value}{unit} eşiğinden büyük sıcaklık",
  "alerts.temperatureLessThan": "Sıcaklık daha az",
  "alerts.temperatureLessThanThreshold": "{value}{unit} eşiğinden daha az sıcaklık",
  "alerts.thresholdOutOfRange": "{min} ile {max} arasında olmalıdır",
  "alerts.thswGreaterThan": "THSW daha büyük",
  "alerts.thswGreaterThanThreshold": "{value}{unit} eşiğinden büyük THSW",
  "alerts.thswLessThan": "THSW daha az",
  "alerts.thswLessThanThreshold": "{value}{unit} eşiğinden daha az THSW",
  "alerts.thwGreaterThan": "THW daha büyük",
  "alerts.thwGreaterThanThreshold": "{value}{unit} eşiğinden büyük THW",
  "alerts.thwLessThan": "THW daha az",
  "alerts.thwLessThanThreshold": "{value}{unit} eşiğinden daha az THW",
  "alerts.triggerHistory": "Uyarı geçmişi",
  "alerts.uvGreaterThan": "UV endeksi daha büyük",
  "alerts.uvGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük UV endeksi",
  "alerts.uvLessThan": "UV endeksi daha az",
  "alerts.uvLessThanThreshold": "{value}{unit} eşiğinden daha az UV endeksi",
  "alerts.visibilityGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük görünürlük",
  "alerts.visibilityLessThanThreshold": "{value}{unit} eşiğinden daha az görünürlük",
  "alerts.visiblityGreaterThan": "Görünürlük daha büyük",
  "alerts.visiblityLessThan": "Görünürlük daha az",
  "alerts.whichMeasure": "Hangi ölçüm için uyarılmak istersiniz?",
  "alerts.whichModule": "Hangi modül için uyarılmak istersiniz?",
  "alerts.whichSensor": "Hangi sensör için uyarılmak istersiniz?",
  "alerts.windChillGreaterThan": "Rüzgâr soğutması daha büyük",
  "alerts.windChillGreaterThanThreshold": "{value}{unit} eşiğinden büyük rüzgâr soğutması",
  "alerts.windChillLessThan": "Rüzgâr soğutması daha az",
  "alerts.windChillLessThanThreshold": "{value}{unit} eşiğinden daha az rüzgâr soğutması",
  "alerts.windSpeedGreaterThan": "Rüzgâr hızı daha büyük",
  "alerts.windSpeedGreaterThanThreshold": "Rüzgâr hızı {value}{unit} eşiğinden daha büyük",
  "alerts.windSpeedLessThan": "Rüzgâr hızı daha az",
  "alerts.windSpeedLessThanThreshold": "Rüzgâr hızı {value}{unit} eşiğinden daha az",
  "appUpdate.updateAvailable": "Güncelleme mevcut",
  "appUpdate.updateAvailableOpenAppStore": "App Store'u açmak için dokunun",
  "appUpdate.updateAvailableOpenGooglePlay": "Google Play'i açmak için dokunun",
  "appUpdate.updateAvailableVersion": "Güncelleme mevcut: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Uygulamanızın güncellenmesi gerekiyor. Güncellemek için Google Play'i ziyaret edin.",
  "appUpdate.upgradeRequiredIos": "Uygulamanızın güncellenmesi gerekiyor. Güncellemek için App Store'u ziyaret edin.",
  "astral.aboveHorizonAllDay": "Tüm gün ufkun üzerinde",
  "astral.aboveTheHorizon": "ufkun üzerinde",
  "astral.apparentSize": "Açısal çap",
  "astral.apparentSizeAcross": "{size} çapında",
  "astral.astronomicalDawn": "Astronomik şafak",
  "astral.astronomicalDusk": "Astronomik alacakaranlık",
  "astral.belowHorizonAllDay": "Tüm gün ufkun altında",
  "astral.belowHorizonSince": "{time} saatinden beri ufkun altında",
  "astral.belowHorizonSinceOn": "{day} {time} saatinden beri ufkun altında",
  "astral.brightAllNight": "Tüm gece aydınlık — hiç tam karanlık olmuyor",
  "astral.brightestMoment": "En aydınlık an",
  "astral.civilDawn": "Sivil şafak",
  "astral.civilDusk": "Sivil alacakaranlık",
  "astral.darkSkyBetween": "Karanlık gökyüzü {from} → {to}",
  "astral.darkSkyWindow": "Karanlık gökyüzü {from} → {to} · Aysız {duration}",
  "astral.dayLength": "Gün uzunluğu",
  "astral.daylightThroughTheYear": "Yıl boyunca gün uzunluğu",
  "astral.dayOfCycle": "{day} / {total} gün",
  "astral.doesNotOccurToday": "Bugün gerçekleşmiyor",
  "astral.domeHint": "Gece boyunca ilerlemek için sürükleyin",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "En erken gündoğumu",
  "astral.earliestSunset": "En erken günbatımı",
  "astral.equinox": "Ekinoks",
  "astral.equinoxIn": "{days} gün sonra ekinoks",
  "astral.evening": "Akşam",
  "astral.exactPhaseAt": "Tam olarak {time}",
  "astral.firstQuarter": "İlk dördün",
  "astral.firstSunriseIn": "{days} gün sonra ilk gündoğumu",
  "astral.firstSunsetIn": "{days} gün sonra ilk günbatımı",
  "astral.fullMoon": "Dolunay",
  "astral.goldenHourBegins": "Altın saat başlıyor",
  "astral.goldenHourEnds": "Altın saat bitiyor",
  "astral.highestPoint": "En yüksek nokta",
  "astral.inDays": "{days} gün sonra",
  "astral.lastQuarter": "Son dördün",
  "astral.latestSunrise": "En geç gündoğumu",
  "astral.latestSunset": "En geç günbatımı",
  "astral.litShort": "Aydınl.",
  "astral.longestDay": "En uzun gün",
  "astral.lowestPoint": "En alçak nokta",
  "astral.maxAltitudeShort": "Maks.",
  "astral.midday": "Öğle",
  "astral.midnightSun": "Gece yarısı güneşi",
  "astral.midnightSunPeriod": "Gece yarısı güneşi",
  "astral.milestoneFootnotePolar": "Burada güneş yılda {days, plural, one {# gün} other {# gün}} ne doğar ne batar; bu yüzden liste olağan en erken/en geç doğuş ve batış yerine bunun ne zaman olduğunu gösterir.",
  "astral.milestoneFootnoteTemperate": "En erken gün batımı ve en geç gün doğumu en kısa güne denk gelmez — bu iki tarihi gündönümü değil, zaman denklemi belirler.",
  "astral.moon": "Ay",
  "astral.moonAltitude": "Yükseklik",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Mesafe",
  "astral.moonlessFor": "Aysız {duration}",
  "astral.moonPhases": "Ay evreleri",
  "astral.moonrise": "Ay doğuşu",
  "astral.moonset": "Ay batışı",
  "astral.moonUpAllNight": "Ay tüm gece ufkun üzerinde",
  "astral.moonWashesOutNight": "Ay {rise} ile {set} arasında ufkun üzerinde ve tüm geceyi aydınlatıyor",
  "astral.morning": "Sabah",
  "astral.nauticalDawn": "Denizcilik şafağı",
  "astral.nauticalDusk": "Denizcilik alacakaranlığı",
  "astral.newMoon": "Yeni ay",
  "astral.nextDay": "+1 gün",
  "astral.nextProperlyDarkNight": "Sonraki gerçekten karanlık gece",
  "astral.nextRise": "sonraki ay doğumu {time}",
  "astral.nextRiseOn": "sonraki ay doğumu {day} {time}",
  "astral.nextSevenNights": "Önümüzdeki yedi gece",
  "astral.nightDate": "Tarih",
  "astral.noAstronomicalDarknessTonight": "Bu gece astronomik karanlık yok",
  "astral.noDarkNightAhead": "Önümüzdeki iki hafta içinde yok",
  "astral.noStationLocation": "Konum bilinmiyor",
  "astral.noStationLocationDescription": "Bu istasyonun kayıtlı bir konumu olmadığından güneş ve ay onun için hesaplanamıyor.",
  "astral.noSunriseToday": "Bugün gün doğumu yok",
  "astral.nowAtBearing": "şimdi {altitude} · azimut {direction}",
  "astral.observing": "Gözlem",
  "astral.ofDaylightLeft": "gün ışığı kaldı",
  "astral.overTheNextThreeWeeks": "önümüzdeki 3 hafta içinde",
  "astral.percentLit": "{percent} aydınlık",
  "astral.polarNight": "Kutup gecesi",
  "astral.polarNightPeriod": "Kutup gecesi",
  "astral.rightNow": "Şu an",
  "astral.riseShort": "Doğuş",
  "astral.setShort": "Batış",
  "astral.shortestDay": "En kısa gün",
  "astral.solarNoon": "Gerçek öğle",
  "astral.solstice": "Gündönümü",
  "astral.sunBelowHorizon": "Güneş ufkun {degrees}° altında",
  "astral.sunEvents": "Güneş olayları",
  "astral.sunNeverDarkEnough": "Güneş hiç ufkun 18° altına inmiyor",
  "astral.sunNeverSets": "Güneş batmıyor",
  "astral.sunrise": "Gündoğumu",
  "astral.sunriseAndSunset": "Gün doğumu ve gün batımı",
  "astral.sunriseAt": "Gün doğumu {time}",
  "astral.sunset": "Gün batımı",
  "astral.sunsetAt": "Gün batımı {time}",
  "astral.thisYearAtNorth": "Bu yıl {degrees}° kuzey enleminde",
  "astral.thisYearAtSouth": "Bu yıl {degrees}° güney enleminde",
  "astral.tonight": "Bu gece",
  "astral.twilightAllNight": "Tüm gece alacakaranlık — hiç tam karanlık olmuyor",
  "astral.upFor": "{duration} ufkun üzerinde",
  "astral.usableLight": "Kullanılabilir ışık",
  "astral.vsAverage": "ortalamaya göre {percent}",
  "astral.vsYesterday": "düne göre",
  "astral.waningCrescent": "Küçülen hilal",
  "astral.waningGibbous": "Küçülen şişkin ay",
  "astral.waxingCrescent": "Büyüyen hilal",
  "astral.waxingGibbous": "Büyüyen şişkin ay",
  "astral.whereToLook": "Nereye bakmalı",
  "astral.withoutTheMoon": "Aysız {duration}",
  "auth.alreadyHaveAccount": "Zaten bir hesabınız var mı?",
  "auth.authContainerTagline": "Kişisel hava durumu panonuz. İstasyonlarınızı bağlayın ve gerçek zamanlı verilere parmaklarınızın ucunda ulaşın.",
  "auth.backToLogin": "Giriş sayfasına dön",
  "auth.checkYourEmail": "E-postanızı kontrol edin",
  "auth.continueWithApple": "Apple ile devam et",
  "auth.continueWithFacebook": "Facebook ile devam et",
  "auth.continueWithGoogle": "Google ile devam et",
  "auth.email": "E-posta adresi",
  "auth.emailRequiredLoginFacebook": "E-posta izni gereklidir.",
  "auth.emailVerification": "E-posta doğrulama",
  "auth.emailVerificationFailure": "E-posta doğrulamanızda bir sorun oluştu.",
  "auth.emailVerificationSuccess": "E-postanız başarıyla doğrulandı.",
  "auth.firstName": "Ad",
  "auth.forgotPassword": "Şifrenizi mi unuttunuz?",
  "auth.forgotPasswordSubtitle": "E-postanızı girin, size şifrenizi sıfırlamak için bir bağlantı göndereceğiz.",
  "auth.lastName": "Soyad",
  "auth.login": "Giriş yap",
  "auth.loginSubtitle": "Tekrar hoş geldiniz! Lütfen bilgilerinizi girin.",
  "auth.loginToSmartMixinDescription": "Hava istasyonlarınıza erişmek, analizleri görüntülemek ve kişisel hava durumu panonuzu yönetmek için SmartMixin'e giriş yapın.",
  "auth.logout": "Oturumu kapat",
  "auth.logoutConfirmation": "Oturumu kapatmak istiyor musunuz?",
  "auth.noAccountYet": "Henüz bir hesabınız yok mu?",
  "auth.or": "veya",
  "auth.password": "Şifre",
  "auth.passwordReset": "Şifre sıfırlama",
  "auth.passwordResetSuccess": "Şifreniz başarıyla güncellendi.",
  "auth.register": "Hesap oluştur",
  "auth.registerDescription": "Hava istasyonlarınızı bağlamak, hava durumu verilerini takip etmek ve güçlü analiz araçlarına erişmek için ücretsiz bir SmartMixin hesabı oluşturun.",
  "auth.registerSubtitle": "Başlamak için hesabınızı oluşturun.",
  "auth.restorePassword": "Şifre sıfırlama",
  "auth.restorePasswordSuccess": "Daha fazla talimat içeren bir şifre sıfırlama bağlantısını {emailAddress} adresine gönderdik.",
  "auth.sendReset": "Sıfırlama talimatlarını gönderin",
  "auth.signInWithApple": "Apple ile Giriş Yap",
  "auth.socialAccount": "veya hesabınızı kullanın",
  "auth.staffVerificationCode": "Doğrulama kodu",
  "auth.staffVerificationExpiresIn": "Doğrulandı. {duration} sonra sona erecek.",
  "auth.staffVerificationInvalidCode": "Kod hatalı. Tekrar deneyin.",
  "auth.staffVerificationLoginAsStopped": "Login As durduruldu: devam etmek için Debug ekranında bir doğrulama kodu girin.",
  "auth.staffVerificationNotEnrolled": "Hesabınız için bir kimlik doğrulama uygulaması ayarlanmamış. Arka ofisin güvenlik ayarlarından bir tane ekleyin.",
  "auth.staffVerificationPasskey": "Geçiş anahtarıyla doğrula",
  "auth.staffVerificationPasskeyExpired": "Geçiş anahtarı isteğinin süresi doldu. Tekrar deneyin.",
  "auth.staffVerificationPasskeyFailed": "Geçiş anahtarıyla doğrulama başarısız oldu. Tekrar deneyin veya bir kod girin.",
  "auth.staffVerificationPasskeyNotEnrolled": "Bu telefonda hesabınız için kullanılabilir bir geçiş anahtarı yok. Arka ofisin güvenlik ayarlarından bu telefonu kullanarak bir tane ekleyin veya bir kod girin.",
  "auth.staffVerificationPasskeySetupLink": "Geçiş anahtarı ekle",
  "auth.staffVerificationPasskeyUnavailable": "Geçiş anahtarları burada kullanılamaz. Bunun yerine bir kod girin.",
  "auth.staffVerificationPrompt": "Login As ve kullanıcı aramasını kullanmak için kimlik doğrulama uygulamanızdaki 6 haneli kodu veya bir kurtarma kodunu girin.",
  "auth.staffVerificationPromptPasskey": "Login As ve kullanıcı aramasını kullanmak için geçiş anahtarınızı kullanın ya da kimlik doğrulama uygulamanızdaki 6 haneli kodu veya bir kurtarma kodunu girin.",
  "auth.staffVerificationSetupLink": "Kimlik doğrulama uygulaması ekle",
  "auth.staffVerificationSubmit": "Doğrula",
  "auth.staffVerificationTitle": "Personel doğrulaması",
  "calendar.afternoon": "Öğleden sonra",
  "calendar.april": "Nisan",
  "calendar.august": "Ağustos",
  "calendar.changePeriod": "Dönem: {period}. Dönemi değiştir",
  "calendar.currentDay": "Geçerli gün",
  "calendar.dateFormat": "Tarih biçimi",
  "calendar.day": "Gün",
  "calendar.december": "Aralık",
  "calendar.durationHours": "{hours} sa",
  "calendar.durationHoursMinutes": "{hours} sa {minutes} dk",
  "calendar.durationMinutes": "{minutes} dk",
  "calendar.durationMinutesSeconds": "{minutes} dk {seconds} sn",
  "calendar.durationSeconds": "{seconds} sn",
  "calendar.earlierYears": "Önceki yıllar",
  "calendar.endTime": "Bitiş zamanı",
  "calendar.evening": "Akşam",
  "calendar.february": "Şubat",
  "calendar.goToNextDay": "Sonraki gün",
  "calendar.goToNextMonth": "Sonraki ay",
  "calendar.goToNextWeek": "Sonraki hafta",
  "calendar.goToNextYear": "Sonraki yıl",
  "calendar.goToPreviousDay": "Önceki gün",
  "calendar.goToPreviousMonth": "Önceki ay",
  "calendar.goToPreviousWeek": "Önceki hafta",
  "calendar.goToPreviousYear": "Önceki yıl",
  "calendar.hour": "Saat",
  "calendar.hoursCount": "{count, plural, one {# saat} other {# saat}}",
  "calendar.hoursShort": "sa",
  "calendar.hoursShortCount": "{count, plural, one {# sa} other {# sa}}",
  "calendar.january": "Ocak",
  "calendar.july": "Temmuz",
  "calendar.june": "Haziran",
  "calendar.last12Hours": "Son 12 saat",
  "calendar.last24Hours": "Son 24 saat",
  "calendar.last30Days": "Son 30 Gün",
  "calendar.last3Hours": "Son 3 saat",
  "calendar.last6Hours": "Son 6 saat",
  "calendar.last7Days": "Son 7 Gün",
  "calendar.lastHour": "Son saat",
  "calendar.laterYears": "Sonraki yıllar",
  "calendar.march": "Mart",
  "calendar.max": "Maksimum",
  "calendar.may": "Mayıs",
  "calendar.month": "Ay",
  "calendar.monthTotal": "Aylık toplam",
  "calendar.morning": "Sabah",
  "calendar.nextHours": "Sonraki Saatler",
  "calendar.night": "Gece",
  "calendar.november": "Kasım",
  "calendar.october": "Ekim",
  "calendar.oneDay": "1 gün",
  "calendar.oneHour": "1 saat",
  "calendar.oneMonth": "1 ay",
  "calendar.oneWeek": "1 hafta",
  "calendar.periodRangeSpoken": "{start} ile {end} arası",
  "calendar.previous24Hours": "Önceki 24 Saat",
  "calendar.previous30Days": "Önceki 30 gün",
  "calendar.previous7Days": "Önceki 7 gün",
  "calendar.previousDay": "Önceki gün",
  "calendar.previousHours": "Önceki saatler",
  "calendar.previousMonth": "Önceki ay",
  "calendar.previousWeek": "Önceki hafta",
  "calendar.previousYear": "Önceki yıl",
  "calendar.sameDayLastYear": "Geçen yıl aynı gün",
  "calendar.sameMonthLastYear": "Geçen yıl aynı ay",
  "calendar.selectADate": "Bir Tarih Seçin",
  "calendar.selectAggregation": "Görüntülenen değeri seçin",
  "calendar.selectAMonth": "Bir Ay Seçin",
  "calendar.selectAYear": "Bir Yıl Seçin",
  "calendar.selectGranularity": "Zaman çözünürlüğünü seçin",
  "calendar.selectPeriod": "Bir Dönem Seçin",
  "calendar.september": "Eylül",
  "calendar.sixHours": "6 saat",
  "calendar.startTime": "Başlangıç Zamanı",
  "calendar.thirtyMinutes": "30 dakika",
  "calendar.threeHours": "3 saat",
  "calendar.timezone": "Zaman dilimi",
  "calendar.today": "Bugün",
  "calendar.untilChanged": "Değişene kadar",
  "calendar.untilTime": "Bitiş: {time}",
  "calendar.untilTodayAt": "Bitiş: bugün {time}",
  "calendar.untilTomorrowAt": "Bitiş: yarın {time}",
  "calendar.use24HourFormat": "24 saat biçimi",
  "calendar.week": "Hafta",
  "calendar.year": "Yıl",
  "calendar.yearToDate": "Sene başından beri",
  "calendar.yesterday": "Dün",
  "charts.averageOverThePeriod": "Dönem boyunca ortalama",
  "charts.calendarView": "Takvim görünümü",
  "charts.charts": "Grafikler",
  "charts.chartView": "Grafik Görünümü",
  "charts.comparison": "Karşılaştırma",
  "charts.customizeComparisonMetrics": "Ölçümleri özelleştir",
  "charts.customizeComparisonMetricsDescription": "Karşılaştırma ölçümlerinizi yeniden sıralamak için öğeleri sürükleyin. Ölçümleri göstermek veya gizlemek için göz simgesine dokunun.",
  "charts.loading": "Grafik yükleniyor",
  "charts.maxOverThePeriod": "Dönem boyunca maksimum",
  "charts.measureToDisplay": "Görüntülemek için ölçüm",
  "charts.minMaxRange": "Min. / Maks.",
  "charts.noDataForThisPeriod": "Bu dönem için veri yok",
  "charts.observations": "Gözlemler",
  "charts.observedTemperature": "Gözlenen sıcaklık",
  "charts.seriesTableDate": "Tarih",
  "charts.showComparison": "Karşılaştırmayı göster",
  "charts.stationComparison": "İstasyon karşılaştırması",
  "charts.stationComparisonDescription": "Tarihsel hava durumu verilerini başka bir istasyonla karşılaştırın",
  "charts.sumOverThePeriod": "Dönem boyunca toplam",
  "charts.tableLabel": "{chart} tablosu",
  "charts.toggleSeries": "{series} göster veya gizle",
  "charts.viewAsChart": "Grafik",
  "charts.viewAsList": "Liste",
  "charts.viewAsPeriods": "Dönemler",
  "charts.viewAsTable": "Tablo",
  "charts.viewLabel": "{chart} görünümü",
  "common.add": "Ekle",
  "common.altitude": "Yükseklik",
  "common.analysis": "Analiz",
  "common.average": "Ortalama",
  "common.back": "Geri",
  "common.backToHome": "Ana Sayfaya Dön",
  "common.cancel": "İptal",
  "common.cannotBeEmpty": "Bu alan boş olamaz.",
  "common.close": "Kapat",
  "common.dailyForecast": "Günlük Tahmin",
  "common.default": "Varsayılan",
  "common.delete": "Sil",
  "common.details": "Detaylar",
  "common.edit": "Düzenle",
  "common.exitFullscreen": "Tam ekrandan çık",
  "common.forecast": "Tahmin",
  "common.frequency": "Sıklık",
  "common.full": "Tam dolu",
  "common.fullscreen": "Tam ekran",
  "common.help": "Yardım",
  "common.hidden": "Gizli",
  "common.high": "Yüksek",
  "common.iDontKnowYet": "Henüz bilmiyorum",
  "common.indoor": "İç mekan",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Son Güncelleme",
  "common.low": "Düşük",
  "common.maximum": "Maksimum",
  "common.medium": "Orta",
  "common.minimum": "Minimum",
  "common.more": "Daha fazla",
  "common.moreInformation": "Daha Fazla Bilgi",
  "common.next": "Sonraki",
  "common.no": "Hayır",
  "common.noAccountNeeded": "Hesap gerekmez",
  "common.noItemsAvailable": "Kullanılabilir öğe yok",
  "common.notNow": "Şimdi Değil",
  "common.now": "Şimdi",
  "common.openSettings": "Ayarları aç",
  "common.outdoor": "Dış mekan",
  "common.pageNotFound": "Sayfa Bulunamadı",
  "common.pageNotFoundDescription": "Aradığınız sayfa mevcut değil veya taşınmış.",
  "common.rain": "Yağmur",
  "common.reorderCancel": "Taşıma iptal edildi: {item}. Yeniden {position} / {count} konumunda.",
  "common.reorderEnd": "Bırakıldı: {item}. Konum {position} / {count}.",
  "common.reorderInstructions": "Bu öğeyi taşımak için Boşluk veya Enter tuşuna basın, yukarı ve aşağı ok tuşlarıyla yerini seçin, ardından bırakmak için yeniden Boşluk veya Enter tuşuna, iptal etmek için Escape tuşuna basın.",
  "common.reorderOver": "{item}: şimdi {position} / {count} konumunda.",
  "common.reorderStart": "Alındı: {item}. Konum {position} / {count}.",
  "common.share": "Paylaş",
  "common.shareImageFailed": "Görsel paylaşılamadı",
  "common.shareYourWeather": "Havanızı Paylaşın",
  "common.skip": "Atla",
  "common.start": "Başla",
  "common.unknown": "Bilinmeyen",
  "common.validate": "Onayla",
  "common.validEmail": "Geçerli bir e-posta adresi gereklidir.",
  "common.very_low": "Çok düşük",
  "common.weatherObservations": "Hava Gözlemleri",
  "common.welcome": "SmartMixin'e hoş geldiniz!",
  "common.wind": "Rüzgâr",
  "common.yes": "Evet",
  "common.zoomImage": "Görseli büyüt",
  "compass.E": "D",
  "compass.E_long": "Doğu",
  "compass.ENE": "DKD",
  "compass.ENE_long": "Doğu-kuzeydoğu",
  "compass.ESE": "DGD",
  "compass.ESE_long": "Doğu-güneydoğu",
  "compass.N": "K",
  "compass.N_long": "Kuzey",
  "compass.NE": "KD",
  "compass.NE_long": "Kuzeydoğu",
  "compass.NNE": "KKD",
  "compass.NNE_long": "Kuzey-kuzeydoğu",
  "compass.NNW": "KKB",
  "compass.NNW_long": "Kuzey-kuzeybatı",
  "compass.NW": "KB",
  "compass.NW_long": "Kuzeybatı",
  "compass.S": "G",
  "compass.S_long": "Güney",
  "compass.SE": "GD",
  "compass.SE_long": "Güneydoğu",
  "compass.SSE": "GGD",
  "compass.SSE_long": "Güney-güneydoğu",
  "compass.SSW": "GGB",
  "compass.SSW_long": "Güney-güneybatı",
  "compass.SW": "GB",
  "compass.SW_long": "Güneybatı",
  "compass.W": "B",
  "compass.W_long": "Batı",
  "compass.WNW": "BKB",
  "compass.WNW_long": "Batı-kuzeybatı",
  "compass.WSW": "BGB",
  "compass.WSW_long": "Batı-güneybatı",
  "dashboard.currentObservations": "Mevcut gözlemler",
  "dashboard.currentRainEvent": "Mevcut yağış olayı",
  "dashboard.currentWeatherConditions": "Mevcut Koşullar",
  "dashboard.customizeDashboard": "Özelleştir",
  "dashboard.customizeDashboardDescription": "Panelinizdeki sıralamayı değiştirmek için öğeleri sürükleyin. Bölümleri göstermek veya gizlemek için göz simgesine dokunun.",
  "dashboard.dashboard": "Gösterge paneli",
  "dashboard.dayRangeExpected": "{value} bekleniyor ({time})",
  "dashboard.dayRangeReached": "{value} ({time})",
  "dashboard.dayRangeSteady": "Gün boyunca sabit {value}",
  "dashboard.hiddenSensors": "Gizli sensörler",
  "dashboard.hideSensor": "{sensor} gizle",
  "dashboard.lastRainEvent": "Son yağış olayı",
  "dashboard.lastVisibleSensor": "En az bir sensör görünür kalmalıdır.",
  "dashboard.manageSensors": "Sensörleri yönet",
  "dashboard.manageSensorsDescription": "Sensörleri yeniden sıralamak için öğeleri sürükleyin. Sensörleri göstermek veya gizlemek için göz simgesine dokunun. Yeniden adlandırmak için bir isme dokunun.",
  "dashboard.manageSensorsDescriptionWeb": "Bir sensörü yeniden adlandırmak için kaleme tıklayın, listeyi yeniden sıralamak için tutamacını sürükleyin, gizlemek veya göstermek için göze tıklayın.",
  "dashboard.moveSensor": "{sensor} taşı",
  "dashboard.pressureSummary": "Basınç özeti",
  "dashboard.rainEvents": "Yağış olayları",
  "dashboard.rainSummary": "Yağmur Özeti",
  "dashboard.renameSensor": "{sensor} yeniden adlandır",
  "dashboard.shareOutdoorMeasures": "Dış mekan ölçümlerinizi paylaşın",
  "dashboard.shareOutdoorMeasuresDescription": "Dış mekan ölçümlerinizi başkalarına görünür kılarak SmartMixin topluluğuna katılın. İç mekan ölçümleri asla paylaşılmaz.",
  "dashboard.showSensor": "{sensor} göster",
  "dashboard.temperatureSummary": "Sıcaklık Özeti",
  "dashboard.useDefaultSensorName": "Varsayılan adı kullan",
  "dashboard.windSummary": "Rüzgâr özeti",
  "devices.batteryLevel": "Pil seviyesi",
  "devices.firmwareVersion": "Ürün yazılımı sürümü",
  "devices.moduleCount": "{count, plural, one {# modül} other {# modül}}",
  "devices.moduleType": "Modül Türü",
  "devices.noNetatmoWeatherStationYet": "Henüz bir Netatmo hava istasyonunuz yok.",
  "devices.noOutdoorModule": "Bu istasyon için işlevsel bir dış mekan modülü yoktur.",
  "devices.notReachable": "Ulaşılamıyor",
  "devices.serialNumber": "Seri numarası",
  "devices.signalAverage": "Orta",
  "devices.signalBad": "Zayıf",
  "devices.signalGood": "İyi",
  "devices.signalStrength": "Sinyal gücü",
  "devices.signalUnknown": "Bilinmeyen",
  "devices.visitNetatmoWebsite": "Netatmo web sitesini ziyaret edin",
  "devices.wifiStrength": "Wi-Fi gücü",
  "forecastMaps.addColor": "Renk ekle",
  "forecastMaps.addLayer": "Katman ekle",
  "forecastMaps.autoDescription": "Bu görünüm için mevcut en iyisi",
  "forecastMaps.autoDescriptionFree": "Ücretsiz hesaplar {model} kullanır",
  "forecastMaps.autoPreview": "Otomatik",
  "forecastMaps.autoSwitched": "Şimdi {model} gösteriliyor: {previous} bu görünümün {coverage, number, percent} kadarını kapsıyor",
  "forecastMaps.backToMaps": "Haritalara dön",
  "forecastMaps.build": "Oluştur",
  "forecastMaps.buildCompleted": "Oluşturma tamamlandı",
  "forecastMaps.builderMetaDescription": "Hava durumu modellerinin katmanlarından özel tahmin haritaları oluşturun.",
  "forecastMaps.builderTitle": "Harita oluşturucu",
  "forecastMaps.buildFailed": "Oluşturma başarısız oldu. Lütfen tekrar deneyin.",
  "forecastMaps.buildNotPossible": "Bu harita henüz oluşturulamıyor — kullanılabilir tahmin verisi yok.",
  "forecastMaps.buildProgress": "İşleniyor… {completed}/{total} adım",
  "forecastMaps.buildStarting": "Oluşturma başlatılıyor…",
  "forecastMaps.byModel": "Modele göre",
  "forecastMaps.byZone": "Bölgeye göre",
  "forecastMaps.colormap": "Renk skalası",
  "forecastMaps.colormapCustom": "Özel renkler",
  "forecastMaps.colormapGroupDomain": "Hava durumu ön ayarları",
  "forecastMaps.colormapGroupMatplotlib": "Bilimsel ön ayarlar",
  "forecastMaps.colorStop": "Renk {position}",
  "forecastMaps.configUnavailable": "Bu tahmin haritası kullanılamıyor. Bunun yerine {name} gösteriliyor.",
  "forecastMaps.contourLevels": "Kontur seviyeleri",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Fransa",
  "forecastMaps.countryGermany": "Almanya",
  "forecastMaps.countryItaly": "İtalya",
  "forecastMaps.countryScandinavia": "İskandinavya",
  "forecastMaps.countrySpain": "İspanya",
  "forecastMaps.countrySwitzerland": "İsviçre",
  "forecastMaps.countryUnitedStates": "Amerika Birleşik Devletleri",
  "forecastMaps.coverageUnknown": "Bölge bilinmiyor",
  "forecastMaps.coversView": "Bu görünümün {coverage, number, percent} kadarını kapsar",
  "forecastMaps.customColormapMinColors": "Özel bir renk skalası en az iki renk gerektirir",
  "forecastMaps.customExtent": "Özel kapsam",
  "forecastMaps.displayName": "Görünen ad",
  "forecastMaps.downscaling": "Rüzgâr oku seyreltme katsayısı",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Alan çiz",
  "forecastMaps.east": "Doğu",
  "forecastMaps.extentDrawHint": "Alanı çizmek için harita üzerinde sürükleyin",
  "forecastMaps.extentInvalid": "Batı doğudan, güney de kuzeyden küçük olmalıdır",
  "forecastMaps.frameTime": "Tahmin zamanı",
  "forecastMaps.height": "Yükseklik (inç)",
  "forecastMaps.hourOffset": "+{hour} sa",
  "forecastMaps.inThisArea": "Bu bölgede",
  "forecastMaps.invalidHexColor": "Geçersiz renk — #RRGGBB kullanın",
  "forecastMaps.layerHasErrors": "Bu katmanda hatalar var",
  "forecastMaps.layers": "Katmanlar",
  "forecastMaps.layerTypeBarbs": "Rüzgâr okları",
  "forecastMaps.layerTypeContour": "Kontur çizgileri",
  "forecastMaps.layerTypeFilledContour": "Dolu konturlar",
  "forecastMaps.layerTypeMagnitude": "Büyüklük",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vektör alanı",
  "forecastMaps.leave": "Ayrıl",
  "forecastMaps.levelsCount": "Adet",
  "forecastMaps.levelsInvalid": "Geçersiz kontur seviyeleri",
  "forecastMaps.levelsModeArange": "Sabit adım",
  "forecastMaps.levelsModeExplicit": "Açık değerler",
  "forecastMaps.levelsModeLinspace": "Eşit aralıklı (adet)",
  "forecastMaps.levelsStep": "Adım",
  "forecastMaps.levelsValues": "Değerler",
  "forecastMaps.levelsValuesHint": "Virgülle ayrılmış, artan",
  "forecastMaps.loadingMaps": "Haritalar yükleniyor…",
  "forecastMaps.localTimeHint": "Yerel saatinizle gösterilir",
  "forecastMaps.lockedConfig": "{model} bir Premium modeldir. Bunun yerine {fallback} gösteriliyor.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Açıklama",
  "forecastMaps.mapName": "Harita adı",
  "forecastMaps.mapNameRequired": "Bir ad girin",
  "forecastMaps.mapSettings": "Harita ayarları",
  "forecastMaps.maxLayersReached": "Bu harita en fazla {max} katman sınırına ulaştı.",
  "forecastMaps.maxValue": "Maksimum değer",
  "forecastMaps.memoryBudgetExceeded": "Çözünürlük işleme bütçesini aşıyor — DPI'ı veya yüksekliği azaltın",
  "forecastMaps.memoryBudgetUsage": "İşleme bütçesi: {percent}%",
  "forecastMaps.metaDescription": "Hava durumu modellerinin çalıştırmalarından üretilen animasyonlu tahmin haritaları.",
  "forecastMaps.metric": "Ölçüm",
  "forecastMaps.metricRequired": "Bir ölçüm seçin",
  "forecastMaps.metricUnavailable": "Bu model için kullanılamıyor",
  "forecastMaps.minBelowMax": "Minimum, maksimumdan küçük olmalıdır",
  "forecastMaps.minMaxRequired": "Bu katman türü için minimum ve maksimum değerler zorunludur",
  "forecastMaps.minValue": "Minimum değer",
  "forecastMaps.modelChipAuto": "Otomatik · {model}",
  "forecastMaps.modelCoversView": "{model} bu görünümün {coverage, number, percent} kadarını kapsıyor",
  "forecastMaps.modelNoRun": "Henüz tamamlanmış bir çalıştırma yok",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.moveLayerDown": "Aşağı taşı",
  "forecastMaps.moveLayerUp": "Yukarı taşı",
  "forecastMaps.nanClipToMin": "Minimuma kırp",
  "forecastMaps.nanMask": "Maskele",
  "forecastMaps.nanPolicy": "Eksik veriler",
  "forecastMaps.nanSkip": "Atla",
  "forecastMaps.noCompletedRun": "Bu harita henüz oluşturulmadı. Lütfen daha sonra tekrar kontrol edin.",
  "forecastMaps.noLayers": "Henüz katman yok. Başlamak için bir katman ekleyin.",
  "forecastMaps.noMapsAvailable": "Henüz kullanılabilir tahmin haritası yok.",
  "forecastMaps.north": "Kuzey",
  "forecastMaps.opacity": "Opaklık",
  "forecastMaps.openAsAnimation": "Animasyon olarak aç",
  "forecastMaps.otherAreas": "Diğer bölgeler",
  "forecastMaps.outsideArea": "Bu bölgeyi kapsamaz",
  "forecastMaps.overlayLegend": "Lejant",
  "forecastMaps.pause": "Duraklat",
  "forecastMaps.play": "Oynat",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "Bu nokta için tahmin yüklenemedi.",
  "forecastMaps.pointValueLoading": "Tahmin yükleniyor…",
  "forecastMaps.pointValueUnavailable": "Bu saat için veri yok.",
  "forecastMaps.premiumModelForView": "{model} bu görünümü kapsıyor",
  "forecastMaps.premiumRequired": "Tahmin haritaları için Premium gerekir",
  "forecastMaps.preview": "Önizleme",
  "forecastMaps.previewEmptyHint": "Önizleme oluşturmak için en az bir geçerli katman yapılandırın.",
  "forecastMaps.previewFailed": "Önizleme başarısız oldu",
  "forecastMaps.previewHour": "Tahmin saati",
  "forecastMaps.previewRendering": "Önizleme işleniyor…",
  "forecastMaps.projection": "Projeksiyon",
  "forecastMaps.projectionLambertConformal": "Lambert konform",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografik",
  "forecastMaps.regionEurope": "Avrupa",
  "forecastMaps.regionNorthAmerica": "Kuzey Amerika",
  "forecastMaps.removeColor": "Rengi kaldır",
  "forecastMaps.removeLayer": "Katmanı kaldır",
  "forecastMaps.retry": "Tekrar dene",
  "forecastMaps.run": "Çalıştırma: {run}",
  "forecastMaps.runNotDisplayable": "Bu çalıştırma etkileşimli haritada gösterilemiyor.",
  "forecastMaps.save": "Kaydet",
  "forecastMaps.selectExtentOnMap": "Haritada alan seç",
  "forecastMaps.showArea": "Bölgeyi göster",
  "forecastMaps.showAreaOf": "Bölgeyi göster, {model}",
  "forecastMaps.south": "Güney",
  "forecastMaps.switchToModel": "{model} modeline geç",
  "forecastMaps.title": "Tahmin haritaları",
  "forecastMaps.uMetric": "U bileşeni",
  "forecastMaps.unitConversion": "Birim dönüştürme",
  "forecastMaps.unitNone": "Yok",
  "forecastMaps.unsavedChangesBody": "Kaydedilmemiş değişiklikleriniz var. Ayrılıp bunlar atılsın mı?",
  "forecastMaps.unsavedChangesTitle": "Kaydedilmemiş değişiklikler",
  "forecastMaps.useCurrentView": "Geçerli görünümü kullan",
  "forecastMaps.useModelDomain": "Kapalı: modelin tüm alanı kullanılır",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U ve V ölçümleri farklı olmalıdır",
  "forecastMaps.valueBetween": "{min} ile {max} arasında olmalıdır",
  "forecastMaps.variable": "Değişken",
  "forecastMaps.variableMissing": "{variable} kullanılamıyor",
  "forecastMaps.variableOnlyFrom": "{variable} yalnızca {model} modelinde var",
  "forecastMaps.viewMap": "Haritayı görüntüle",
  "forecastMaps.vMetric": "V bileşeni",
  "forecastMaps.west": "Batı",
  "forecastMaps.windAnimation": "Rüzgâr animasyonu",
  "forecastModels.addForecastModel": "Model ekle",
  "forecastModels.atYourStations": "İstasyonlarınızda mevcut",
  "forecastModels.comparisonLoadError": "Tahmin modeli karşılaştırması yüklenemedi",
  "forecastModels.coverageLoading": "Her modelin hangi istasyonlarınızı kapsadığı hesaplanıyor…",
  "forecastModels.description_AROME": "Météo France'ın Batı Avrupa üzerinde 1,3 km çözünürlükte konveksiyonu çözen yüksek çözünürlüklü modeli. Fransa'daki kısa vadeli tahminler için sınıfının en iyisi; üç saatte bir güncellenir.",
  "forecastModels.description_ARPEGE_EU": "Météo France'ın ARPEGE modelinin 10 km çözünürlükteki Avrupa alt alanı. Avrupa üzerinde orta vadeli tahminler, günde dört kez güncellenir.",
  "forecastModels.description_ARPEGE_GLOBAL": "Météo France'ın 25 km çözünürlükte yaklaşık 4 güne kadar çalışan küresel sayısal hava tahmin modeli. Günde dört kez güncellenir.",
  "forecastModels.description_DMI_DINI": "DMI'nin HARMONIE DINI modeli: kuzeybatı Avrupa — Danimarka, Benelüks, İrlanda, Birleşik Krallık ve İskandinavya — üzerinde 2 km çözünürlükte, 60 saate kadar çalışan, konveksiyonu çözen bir model, günde sekiz kez güncellenir. Değiştirilmiş DMI açık verilerini içerir (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Environment Canada'nın Küresel Deterministik Tahmin Sistemi: 15 km çözünürlükte 10 güne kadar çalışan dünya çapında orta vadeli model, günde iki kez güncellenir.",
  "forecastModels.description_EC_HRDPS": "Environment Canada'nın Yüksek Çözünürlüklü Deterministik Tahmin Sistemi: Kanada ve kuzey ABD üzerinde 2,5 km çözünürlükte, 48 saate kadar çalışan, konveksiyonu çözen bir model, günde dört kez güncellenir.",
  "forecastModels.description_EC_RDPS": "Environment Canada'nın Bölgesel Deterministik Tahmin Sistemi: Kuzey Amerika üzerinde 10 km çözünürlükte orta vadeli model, günde dört kez güncellenir.",
  "forecastModels.description_ECMWF_HRES": "Avrupa Orta Vadeli Hava Tahminleri Merkezi'nin amiral gemisi yüksek çözünürlüklü modeli (IFS), dünyanın önde gelen küresel tahmin sistemi olarak kabul edilir. Tüm gezegeni 25 km çözünürlükle 15 güne kadar kapsar, günde dört kez güncellenir. Değiştirilmiş ECMWF açık verilerini içerir (CC BY 4.0).",
  "forecastModels.description_GFS": "NOAA'nın amiral gemisi orta vadeli küresel modeli. Tüm gezegeni 25 km çözünürlükte 16 güne kadar kapsar, günde dört kez güncellenir.",
  "forecastModels.description_HRRR_CONUS": "NOAA'nın High-Resolution Rapid Refresh modeli: kıta ABD üzerinde 3 km çözünürlükte konveksiyonu çözen model, her saat güncellenir. Fırtınalar ve şiddetli hava koşullarının çok kısa vadeli tahminleri için en uygundur.",
  "forecastModels.description_ICON": "DWD'nin 13 km çözünürlüğünde, tüm gezegeni 7,5 güne kadar kapsayan ve günde dört kez güncellenen küresel ICON modeli. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ItaliaMeteo'nun ARPAE ile birlikte işlettiği ICON-2I modeli: İtalya üzerinde 2,2 km çözünürlükte, 72 saate kadar çalışan, konveksiyonu çözen bir model, günde iki kez güncellenir. ItaliaMeteo açık verilerini içerir (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "MeteoSwiss'in ICON-CH1-EPS kontrol koşusu: Alpler üzerinde 1 km çözünürlükte, 33 saate kadar çalışan, konveksiyonu çözen bir model, üç saatte bir güncellenir.",
  "forecastModels.description_ICON_CH2": "MeteoSwiss'in ICON-CH2-EPS kontrol koşusu: Alpler — İsviçre ve çevresindeki Alp bölgesi — üzerinde 2,1 km çözünürlükte, 120 saate kadar çalışan, konveksiyonu çözen bir model, günde dört kez güncellenir.",
  "forecastModels.description_ICON_DE": "DWD'nin Almanya ve çevre ülkeler üzerinde 2,2 km çözünürlükte konveksiyonu çözen yüksek çözünürlüklü modeli. Kısa vadeli tahminler günde iki kez güncellenir. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "DWD'nin ICON modelinin Avrupa ve Kuzey Atlantik'i kapsayan 7 km çözünürlükteki Avrupa alt alanı. Orta vadeli tahminler günde dört kez güncellenir. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Norveç Meteoroloji Enstitüsü'nün açık hava tahmini hizmeti, yüksek çözünürlüklü İskandinav modellerini ECMWF verileriyle birleştirerek 10 güne kadar dünya çapında tahminler sunar.",
  "forecastModels.description_MF_AROME_ANTILLES": "Fransız Antilleri (Guadeloupe, Martinique) üzerinde 2,5 km çözünürlükte AROME alt alanı. Kısa vadeli tahminler günde dört kez güncellenir.",
  "forecastModels.description_MF_AROME_GUYANE": "Fransız Guyanası üzerinde 2,5 km çözünürlükte AROME alt alanı. Kısa vadeli tahminler günde dört kez güncellenir.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Yeni Kaledonya üzerinde 2,5 km çözünürlükte AROME alt alanı. Kısa vadeli tahminler günde dört kez güncellenir.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Fransız Polinezyası üzerinde 2,5 km çözünürlükte AROME alt alanı. Kısa vadeli tahminler günde dört kez güncellenir.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Réunion ve Mayotte üzerinde 2,5 km çözünürlükte AROME alt alanı. Kısa vadeli tahminler günde dört kez güncellenir.",
  "forecastModels.description_RRFS_CONUS": "NOAA'nın Rapid Refresh Forecast sistemi, kıta ABD üzerinde 3 km çözünürlükte. Günde sekiz kez yenilenen saatlik tahminler; dört ana koşuda 84 saate, diğerlerinde 18 saate kadar uzanır.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "NOAA'nın tüm Kuzey Amerika'yı 13 km çözünürlükte kapsayan Rapid Refresh Forecast sistemi. 84 saate kadar saatlik tahminler, günde dört kez yenilenir.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "SmartMixin'in amiral gemisi tahmini. Konumunuzdaki her saat için mevcut en iyi modeli seçiyoruz — genellikle bir tane varsa yüksek çözünürlüklü bir bölgesel model (Fransa'da AROME, Almanya'da ICON-D2, ABD'de HRRR, kıtanın her yerinde ARPEGE Europe…) ve başka yerlerde küresel bir modele geri dönüyoruz — sonra komşu kaynaklardan boşlukları dolduruyoruz. Sonuç, dünyanın herhangi bir yerini 14 güne kadar kapsayan tek bir kesintisiz tahmindir ve altta yatan modellerden herhangi biri güncellendiğinde otomatik olarak yenilenir.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Birden fazla sayısal hava tahmin modelini, Tempest hava istasyonu ağından gelen gözlemlerle birleştiren Weatherflow'un tescilli küresel tahmini. Dünya çapında 10 günlük tahmin süresi.",
  "forecastModels.everywhereElse": "Diğer her yerde",
  "forecastModels.everywhereElseFoot": "Tercih ettiğiniz modellerin ulaşmadığı her istasyonda kullanılır.",
  "forecastModels.everywhereElsePick": "Birini seçin",
  "forecastModels.fallbackBlend": "SmartMixin karışımı",
  "forecastModels.fallbackBlendSub": "Birden fazla modeli, her birini en güçlü olduğu yerde birleştirir.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "Ulaştığı her yerde ECMWF HRES.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "NOAA'nın küresel modeli. Bugün her hesabın kullandığı model.",
  "forecastModels.fallbackResolution": "En yüksek çözünürlük",
  "forecastModels.fallbackResolutionSub": "Her istasyonda mevcut olan en ince ağ.",
  "forecastModels.forecastChipLabelWithRun": "{model}, çalıştırma {run}",
  "forecastModels.forecastChipRunHint": "En son çalıştırmayı göstermek veya gizlemek için uzun basın",
  "forecastModels.forecastComparisonDescription": "Birkaç kaynaktan tahmin modeli çıktılarını kolayca karşılaştırın",
  "forecastModels.forecastFollowingPreferences": "Tercihlerinize göre",
  "forecastModels.forecastLoadError": "Tahmin yüklenemedi",
  "forecastModels.forecastModel": "Tahmin modeli",
  "forecastModels.forecastModelAbout": "{model} hakkında",
  "forecastModels.forecastModelComparison": "Tahmin modeli karşılaştırması",
  "forecastModels.forecastModelCoverage": "Kapsama",
  "forecastModels.forecastModelDescription": "Açıklama",
  "forecastModels.forecastModels": "Tahmin modelleri",
  "forecastModels.forecastModelScopeGlobal": "Küresel",
  "forecastModels.forecastModelScopeGlobalDescription": "Bu model tüm gezegeni kapsar.",
  "forecastModels.forecastModelScopeRegional": "Bölgesel",
  "forecastModels.forecastModelScopeRegionalDescription": "Bu model yalnızca belirli bir bölgeyi kapsar.",
  "forecastModels.forecastModelSpecifications": "Özellikler",
  "forecastModels.forecastNoPinLocation": "Hiçbir tercih edilen model bu konuma ulaşmıyor — “diğer her yerde” karar verir.",
  "forecastModels.forecastNoPinStation": "Hiçbir tercih edilen model bu istasyona ulaşmıyor — “diğer her yerde” karar verir.",
  "forecastModels.forecastNoPreferredModels": "Henüz tercih edilen model ayarlanmadı.",
  "forecastModels.forecastOverrideElsewhere": "Tercihleriniz diğer her yerde geçerlidir.",
  "forecastModels.forecastPickForLocation": "Ya da bu konum için birini seçin",
  "forecastModels.forecastPickForStation": "Ya da bu istasyon için birini seçin",
  "forecastModels.forecastPinWinsLocation": "{model} — bu konuma ulaşan ilk tercih edilen modeliniz.",
  "forecastModels.forecastPinWinsStation": "{model} — bu istasyona ulaşan ilk tercih edilen modeliniz.",
  "forecastModels.forecastServedNowHere": "Şu anda burada: {model}",
  "forecastModels.forecastSetForLocation": "Bu konum için ayarlandı",
  "forecastModels.forecastSetForStation": "Bu istasyon için ayarlandı",
  "forecastModels.forecastSettingsRowSub": "Tercih edilen modeller ve diğer her yerde geçerli olan",
  "forecastModels.forecastStopUsingHere": "Burada kullanma",
  "forecastModels.forecastUseForLocation": "Bu konum için {model} kullan",
  "forecastModels.forecastUseForStation": "Bu istasyon için {model} kullan",
  "forecastModels.forecastUsePreferred": "Tercih ettiğim modelleri kullan",
  "forecastModels.frequencyHourly": "Saatte bir",
  "forecastModels.horizon": "Tahmin süresi",
  "forecastModels.horizonValue": "{value} saate kadar",
  "forecastModels.meshSize": "Izgara boyutu",
  "forecastModels.pickerShowAll": "Tüm kataloğu göster",
  "forecastModels.pickerUnreachable": "{count, plural, one {# model daha} other {# model daha}} istasyonlarınızın hiçbirine ulaşmıyor",
  "forecastModels.pinInUse": "Kullanımda",
  "forecastModels.pinShadowed": "Hiç kullanılmıyor — yukarıdaki bir model tüm istasyonlarınızı kapsıyor",
  "forecastModels.pinSlots": "{max} yuvadan {used} tanesi · bir model seçin",
  "forecastModels.pinSlotsFull": "{max, plural, one {Tek yuva dolu. Başka bir model eklemek için bu yuvadaki modeli kaldırın.} other {# yuvanın tamamı dolu. Başka bir tane eklemek için birini kaldırın.}}",
  "forecastModels.pinsUncoveredCount": "{count, plural, other {# istasyonunuzdan}} {used} tanesi: hiçbir tercih edilen model {used, plural, =1 {ona} other {onlara}} ulaşmıyor — “diğer her yerde” karar verir.",
  "forecastModels.pinsUncoveredNamed": "{stations}: hiçbir tercih edilen model {count, plural, one {ona} other {onlara}} ulaşmıyor — “diğer her yerde” karar verir.",
  "forecastModels.pinUnreachable": "Hiç kullanılmıyor — istasyonlarınızın hiçbirine ulaşmıyor",
  "forecastModels.pinUsedAt": "Şurada kullanılıyor: {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {İstasyonunuzda kullanılıyor} other {# istasyonun tamamında kullanılıyor}}",
  "forecastModels.pinUsedAtSome": "{count, plural, other {# istasyondan}} {used} tanesinde kullanılıyor",
  "forecastModels.preferredModels": "Tercih edilen modeller",
  "forecastModels.preferredModelsAll": "Tek liste, tüm istasyonlar",
  "forecastModels.preferredModelsOne": "Tek liste, her yerde geçerli",
  "forecastModels.publisher": "Yayıncı",
  "forecastModels.removePreferredModel": "{model} modelini tercih ettiğiniz modellerden kaldır",
  "forecastModels.resetForecastPreference": "Sıfırla",
  "forecastModels.resetForecastPreferenceHint": "Tercih ettiğiniz modelleri siler ve SmartMixin varsayılanına döner.",
  "forecastModels.servedNowMany": "Şu anda: {count, plural, one {istasyonunuzda} other {# istasyonun tamamında}} GFS.",
  "forecastModels.servedNowNone": "Şu anda: her yerde GFS.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin çoklu model",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Weatherflow Tahmini",
  "forecastModels.weatherForecastModels": "Hava Tahmin Modelleri",
  "helpCenter.articleCount": "{count} makale",
  "helpCenter.articleNotFound": "Makale Bulunamadı",
  "helpCenter.articleNotFoundDescription": "Aradığınız makale mevcut değil.",
  "helpCenter.backToHelpCenter": "Yardım Merkezine Dön",
  "helpCenter.browseByCategory": "Kategoriye göre göz at",
  "helpCenter.categoryNotFound": "Kategori bulunamadı",
  "helpCenter.categoryNotFoundDescription": "Bu kategori mevcut değil veya makale içermiyor.",
  "helpCenter.contactSupport": "Destekle iletişime geçin",
  "helpCenter.feedbackHelpsImprove": "Görüşleriniz yardım makalelerimizi geliştirmemize yardımcı oluyor.",
  "helpCenter.feedbackReasonNotAnswer": "Sorumu yanıtlamıyor",
  "helpCenter.feedbackReasonOutdated": "Bilgiler güncel değil",
  "helpCenter.feedbackReasonUnclear": "Talimatlar net değil",
  "helpCenter.feedbackWhatWentWrong": "Sorun neydi?",
  "helpCenter.helpCategoryAccount": "Hesap",
  "helpCenter.helpCategoryBilling": "Faturalandırma",
  "helpCenter.helpCategoryForecast": "Tahminler",
  "helpCenter.helpCategoryGettingStarted": "Başlarken",
  "helpCenter.helpCategoryProviders": "Sağlayıcılar",
  "helpCenter.helpCategoryStations": "İstasyonlar",
  "helpCenter.helpCategoryTroubleshooting": "Sorun Giderme",
  "helpCenter.helpCenter": "Yardım Merkezi",
  "helpCenter.landingDescription": "Sık sorulan sorulara yanıtlar bulun ve SmartMixin'den en iyi şekilde nasıl yararlanacağınızı öğrenin.",
  "helpCenter.linkToSection": "Bu bölüme bağlantı",
  "helpCenter.menuItemDescription": "SSS ve kılavuzlar",
  "helpCenter.minRead": "{minutes} dk okuma",
  "helpCenter.onThisPage": "Bu sayfada",
  "helpCenter.platformMobileApp": "Mobil uygulama",
  "helpCenter.platformMobileOnly": "Yalnızca mobil uygulamada",
  "helpCenter.platformWebApp": "Web uygulaması",
  "helpCenter.platformWebOnly": "Yalnızca web uygulamasında",
  "helpCenter.popularArticles": "Popüler makaleler",
  "helpCenter.relatedArticles": "İlgili Makaleler",
  "helpCenter.searchArticles": "Makale ara...",
  "helpCenter.stillNeedHelp": "Hâlâ yardıma mı ihtiyacınız var?",
  "helpCenter.stillNeedHelpDescription": "Bu makale sorunuzu yanıtlamadıysa size doğrudan yardımcı olmaktan memnuniyet duyarım.",
  "helpCenter.supportEmailSubject": "SmartMixin Yardım",
  "helpCenter.supportEmailSubjectTopic": "SmartMixin Yardım — {topic}",
  "helpCenter.thankYouForFeedback": "Geri bildiriminiz için teşekkürler!",
  "helpCenter.wasArticleHelpful": "Bu makale yardımcı oldu mu?",
  "intro.locationDescription": "Bulunduğun konuma özel doğru tahminler almak için konum erişimini etkinleştir — artık genel tahminlere son.",
  "intro.locationTitle": "Sana özel tahminler",
  "intro.notificationDescription": "Yağmur, kar veya şiddetli hava koşulları gibi önemli değişiklikleri zamanında öğrenmek için bildirimleri aç.",
  "intro.notificationsTitle": "Hava değişikliklerini kaçırmayın",
  "intro.readyDescription": "Kesin tahminler, gerçek zamanlı hava durumu içgörüleri ve dünya çapındaki istasyon verileri — hepsi güçlü bir uygulamada.",
  "intro.readyTitle": "Hazırsınız!",
  "intro.welcomeDescription": "En iyi hava durumu ajanslarının sağladığı hiper yerel tahminler ve dünya genelindeki 40.000'den fazla hava istasyonuna erişim ile geçmiş ve mevcut gerçek koşulları görün.",
  "intro.welcomeTitle": "Havanız, yeniden tasarlandı",
  "landing.alsoAvailableOn": "Şurada da mevcut:",
  "landing.featureAlertsDescription": "Herhangi bir ölçüm için özel eşikler belirleyin. Sıcaklık düştüğünde, yağmur başladığında veya rüzgâr güçlendiğinde bildirim alın.",
  "landing.featureAlertsTitle": "Akıllı uyarılar",
  "landing.featureAnalyticsDescription": "Etkileşimli grafikler, trend analizi ve ayrıntılı istatistikler. Sıcaklık, nem, basınç, yağmur ve rüzgâr verilerini derinlemesine inceleyin.",
  "landing.featureAnalyticsTitle": "Gelişmiş analitik",
  "landing.featureExportDescription": "Tüm hava durumu verilerinizi e-postayla bir Excel tablosu olarak alın; Excel, Google E-Tablolar veya favori araçlarınızda daha ayrıntılı analize hazır.",
  "landing.featureExportTitle": "Verilerinizi dışa aktarın",
  "landing.featureForecastDescription": "ECMWF, GFS ve bölgesel modeller dahil {count, plural, one {#+ profesyonel tahmin modeline} other {#+ profesyonel tahmin modeline}} erişin. Kendi tahminlerinizi yapmak için bunları yan yana karşılaştırın.",
  "landing.featureForecastTitle": "Tahmin modellerini karşılaştırın",
  "landing.featureHistoryDescription": "Saatlik, günlük ve aylık ölçekli geçmiş verilere erişin. Araştırma veya kişisel arşivler için Excel'e aktarın.",
  "landing.featureHistoryTitle": "Zengin geçmiş",
  "landing.featureMultiBrandDescription": "Netatmo, Davis, Tempest, Ecowitt, Ambient Weather ve daha fazlasını bağlayın. Artık uygulamalar arasında geçiş yapmanıza gerek yok.",
  "landing.featureMultiBrandTitle": "Tüm markalar, tek uygulama",
  "landing.featuresSubtitle": "SmartMixin, hava durumu verilerinizi bir profesyonel gibi analiz etmeniz, karşılaştırmanız ve anlamanız için gereken araçları sunar.",
  "landing.featuresTitle": "Veri tutkunları için tasarlandı",
  "landing.finalCtaButton": "Ücretsiz hesap oluşturun",
  "landing.finalCtaSubtitle": "SmartMixin'e güvenen binlerce hava durumu meraklısına katılın.",
  "landing.finalCtaTitle": "Hava durumu verilerinize daha derinlemesine dalmaya hazır mısınız?",
  "landing.heroCta": "Ücretsiz başlayın",
  "landing.heroDescription": "Derinlemesine analizler, şık grafikler ve profesyonel tahminler — tüm hava istasyonlarınız tek bir güçlü uygulamada.",
  "landing.heroSecondaryCta": "Haritayı keşfedin",
  "landing.heroTagline": "Hava durumu meraklıları için",
  "landing.heroTitle": "Hava durumunuzu daha önce hiç görmediğiniz gibi görün",
  "landing.pricingComparisonCaption": "Ücretsiz ve Premium plan özelliklerinin karşılaştırması",
  "landing.pricingFeatureAdvancedMetrics": "Gelişmiş metrikler",
  "landing.pricingFeatureAlerts": "Özel uyarılar",
  "landing.pricingFeatureColumn": "Özellik",
  "landing.pricingFeatureExport": "Veri dışa aktarma (Excel)",
  "landing.pricingFeatureForecastComparison": "Tahmin karşılaştırma",
  "landing.pricingFeatureForecasts": "Tahmin modelleri",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ model} other {#+ model}}",
  "landing.pricingFeatureReports": "Analizler ve raporlar",
  "landing.pricingFeatureStationComparison": "İstasyon karşılaştırması",
  "landing.pricingFeatureWidgets": "Ana ekran widget'ları",
  "landing.pricingFeatureYearOverYear": "Yıldan yıla analiz",
  "landing.pricingFreeCta": "Başlayın",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "En popüler",
  "landing.pricingPremiumCta": "Başlayın",
  "landing.pricingPremiumDescription": "Aylık 1,99 €'den başlayan fiyatlarla — web, App Store veya Google Play'den abone olun",
  "landing.pricingSubtitle": "Ücretsiz başlayın, daha fazlasına ihtiyaç duyduğunuzda yükseltin.",
  "landing.pricingTitle": "Basit, şeffaf fiyatlandırma",
  "landing.statBrands": "Desteklenen marka",
  "landing.statForecasts": "Tahmin modeli",
  "landing.statStations": "Hava istasyonu",
  "landing.supportedDevicesNote": "Ayrıca Dünya Meteoroloji Örgütü ağından {count, number}+ kamuya açık istasyon",
  "landing.supportedDevicesSubtitle": "Mevcut hava istasyonunuzu dakikalar içinde bağlayın. {count, plural, one {# büyük markayı} other {# büyük markayı}} destekliyoruz ve bu sayı artıyor.",
  "landing.supportedDevicesTitle": "İstasyonunuzla çalışır",
  "metrics.absolutePressure": "Mutlak basınç",
  "metrics.airDensity": "Hava yoğunluğu",
  "metrics.airGap": "Hava boşluğu",
  "metrics.apparentTemperature": "Hissedilen sıcaklık",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Ort.",
  "metrics.avg_wind": "Ortalama rüzgâr",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Siyah küre sıcaklığı",
  "metrics.boilerOn": "Kazan",
  "metrics.boilerOnInHours": "Kazan (saat)",
  "metrics.cloudCover": "Bulut örtüsü",
  "metrics.co2": "CO2",
  "metrics.conductivity": "İletkenlik",
  "metrics.dailyPrecipitation": "Günlük yağış",
  "metrics.dailyRain": "Günlük yağış",
  "metrics.degreeDayShort": "DD",
  "metrics.depth": "Derinlik",
  "metrics.depthSensors": "Derinlik sensörleri",
  "metrics.dewPoint": "Çiy noktası",
  "metrics.distance": "Mesafe",
  "metrics.downTrend": "aşağı",
  "metrics.ET": "Evapotranspirasyon",
  "metrics.etToday": "ET bugün",
  "metrics.feelsLike": "Hissedilen",
  "metrics.feelsLikeWithFormula": "Hissedilen ({formula})",
  "metrics.frostPoint": "Kırağı noktası",
  "metrics.gust": "Rüzgâr hamlesi",
  "metrics.gustDirection": "Rüzgâr hamlesi yönü",
  "metrics.hail": "Dolu",
  "metrics.heatIndex": "Isı indeksi",
  "metrics.heatingDegreeDays": "Isıtma derece günleri",
  "metrics.heatingPower": "Isıtma gücü",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Nem",
  "metrics.lastLightningImpact": "Son yıldırım",
  "metrics.lastMeasure": "Son ölçüm",
  "metrics.leafSensors": "Yaprak sensörleri",
  "metrics.leafWetness": "Yaprak ıslaklığı",
  "metrics.lightningDistance": "Mesafe",
  "metrics.lightningStrikeCount": "Yıldırım çarpması sayısı",
  "metrics.lightningStrikeDistance": "Yıldırım çarpması mesafesi",
  "metrics.max": "Maks.",
  "metrics.max_gust": "Maks. rüzgâr hamlesi",
  "metrics.maxToday": "Bugün maks.",
  "metrics.min": "Min.",
  "metrics.noise": "Gürültü",
  "metrics.normalizedHeatingCoefficient": "Normalleştirilmiş ısıtma katsayısı",
  "metrics.outdoorTemperature": "Dış mekan sıcaklığı",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2.5",
  "metrics.precipitation": "Yağış",
  "metrics.pressure": "Basınç",
  "metrics.rain": "Yağmur",
  "metrics.rainDurationValue": "Yağış süresi: {duration}",
  "metrics.rainfallMeasurement": "Yağış ölçümü",
  "metrics.rainRate": "Yağış yoğunluğu",
  "metrics.relativePressure": "Göreceli basınç",
  "metrics.setPoint": "Ayar noktası",
  "metrics.snow": "Kar",
  "metrics.snowfall": "Kar yağışı",
  "metrics.soilMoisture": "Nem",
  "metrics.soilSensors": "Toprak sensörleri",
  "metrics.soilWaterTension": "Toprak su gerilimi",
  "metrics.solarEnergy": "Güneş enerjisi",
  "metrics.solarRadiation": "Güneş radyasyonu",
  "metrics.speed": "Hız",
  "metrics.stableTrend": "stabil",
  "metrics.sum": "Toplam",
  "metrics.temperature": "Sıcaklık",
  "metrics.temperatureSensors": "Sıcaklık ve nem sensörleri",
  "metrics.temperatureShort": "Sıcaklık",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "yukarı",
  "metrics.uv": "UV",
  "metrics.visibility": "Görüş mesafesi",
  "metrics.weatherCondition": "Hava durumu",
  "metrics.wetBulbGlobeTemperature": "Islak küre sıcaklığı",
  "metrics.wetBulbTemperature": "Yaş termometre sıcaklığı",
  "metrics.wind": "Rüzgâr",
  "metrics.windChill": "Rüzgâr soğutması",
  "metrics.windDirection": "Rüzgâr yönü",
  "metrics.windMeasurement": "Rüzgâr ölçümü",
  "metrics.windRun": "Rüzgâr mesafesi",
  "metrics.windRunDescription": "Rüzgâr mesafesi, rüzgârın belirli bir süre boyunca kat ettiği toplam mesafedir",
  "metrics.windSpeed": "Rüzgâr hızı",
  "navigation.allFavorites": "Tümünü gör",
  "navigation.breadcrumbs": "İçerik haritası",
  "navigation.collapseNavigation": "Gezinmeyi daralt",
  "navigation.expandNavigation": "Gezinmeyi genişlet",
  "navigation.main": "Ana",
  "navigation.mapShort": "Harita",
  "navigation.skipToContent": "Ana içeriğe atla",
  "navigation.stationsShort": "İstasyonlar",
  "network.cancelError": "İstek iptal edildi",
  "network.connectionError": "Sunucu mevcut değil",
  "network.networkError": "Ağ mevcut değil",
  "network.serverError": "Bir şeyler ters gitti ...",
  "network.timeoutError": "Bağlantı Zaman Aşımı",
  "network.unknownError": "Bilinmeyen hata",
  "premium.alreadyPremium": "Zaten premium bir hesabınız var!",
  "premium.bestValue": "En avantajlı",
  "premium.billingDetailsAndroid": "Ücretsiz deneme: Deneme süresi bitmeden en az 24 saat önce iptal ederseniz ücret alınmaz. Sonrasında SmartMixin aboneliğiniz, geçerli dönemin bitiminden en az 24 saat önce iptal etmediğiniz sürece otomatik olarak yenilenir; Google Play hesap ayarlarınızdan istediğiniz zaman iptal edebilirsiniz. Her yenileme, yukarıdaki düğmede gösterilen fiyattan ücretlendirilir. Ödeme, satın alma işlemini onayladığınızda ve her yenileme döneminin başında Google Play hesabınızdan tahsil edilir.",
  "premium.billingDetailsIos": "Ücretsiz deneme: Deneme süresi bitmeden en az 24 saat önce iptal ederseniz ücret alınmaz. Sonrasında SmartMixin aboneliğiniz, geçerli dönemin bitiminden en az 24 saat önce iptal etmediğiniz sürece otomatik olarak yenilenir; App Store hesap ayarlarınızdan istediğiniz zaman iptal edebilirsiniz. Her yenileme, yukarıdaki düğmede gösterilen fiyattan ücretlendirilir. Ödeme, satın alma işlemini onayladığınızda ve her yenileme döneminin başında App Store hesabınızdan tahsil edilir.",
  "premium.freeBannerBody": "Ücretsiz hesaplara her yerde GFS sunulur — tercih edilen modelleriniz ve “diğer her yerde” abone olduğunuz anda çalışmaya başlar.",
  "premium.freeBannerTitle": "Tercihler Premium ile geçerlidir",
  "premium.freeSubscription": "Ücretsiz premium abonelik",
  "premium.freeTrialForPeriod": "{period, plural, one {# gün} other {# gün}} ücretsiz deneme",
  "premium.getUnlimitedAccess": "Sınırsız erişim:",
  "premium.manageMySubscription": "Aboneliğimi yönetin",
  "premium.notPurchasedYet": "Bu mağaza hesabında SmartMixin Premium satın alımı bulunamadı.",
  "premium.orChooseMonthly": "Veya aylık seçin:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Aktif",
  "premium.premiumAnnualTrialInfo": "{days, plural, one {# günlük} other {# günlük}} ücretsiz deneme ile başlayın",
  "premium.premiumCurrentPlan": "Mevcut Plan",
  "premium.premiumDownloadApp": "Abone olmak için uygulamayı indirin:",
  "premium.premiumEndsOn": "{date} tarihinde sona erer",
  "premium.premiumFeatureAlerts": "Hava Uyarıları",
  "premium.premiumFeatureAnalysis": "Gelişmiş Hava Analizi",
  "premium.premiumFeatureCharts": "Grafik Karşılaştırmaları",
  "premium.premiumFeatureExport": "Veri Dışa Aktarma",
  "premium.premiumFeatureForecast": "Bölgesel Tahmin Modelleri",
  "premium.premiumFeatureNotification": "Durum Çubuğu Widget'ı",
  "premium.premiumFeatureTitle": "Premium Özellik",
  "premium.premiumFeatureWidgets": "Ana ekran widget'ları",
  "premium.premiumFreePlan": "Ücretsiz",
  "premium.premiumInactive": "Abone değil",
  "premium.premiumManageStoreSubscription": "{store} üzerinden abone oldunuz. Aboneliğinizi oradan yönetebilir veya iptal edebilirsiniz.",
  "premium.premiumManageWebSubscription": "Aboneliğinizi yönetin, ödeme yöntemini güncelleyin veya iptal edin.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "{date} tarihinde yenilenir",
  "premium.premiumSubscribeAnnual": "Yıllık — 9,99 €/yıl",
  "premium.premiumSubscribedOn": "{platform} üzerinden abone olundu",
  "premium.premiumSubscribedOnWeb": "Web üzerinden abone olundu",
  "premium.premiumSubscribeMonthly": "Aylık — 1,99 €/ay",
  "premium.premiumSubscribeOnWeb": "Tüm premium özelliklerin kilidini açmak için şimdi abone olun.",
  "premium.premiumSubscriptionSuccess": "Aboneliğiniz etkinleştirildi! Tüm premium özelliklerin keyfini çıkarın.",
  "premium.premiumSubscriptionSuccessTitle": "Premium'a hoş geldiniz!",
  "premium.premiumWebappNotice": "Web üzerinden abonelik şu anda kullanılamıyor.",
  "premium.pricePerMonth": "{price}/ay",
  "premium.pricePerYear": "{price}/yıl",
  "premium.purchasedNetatmoPro": "Daha önce Netatmo Pro satın aldınız ({date}). Bu, premium özelliklerin bir kısmına erişmenizi sağlar. Tüm premium özelliklere erişmek istiyorsanız aşağıdaki tekliflerden birine abone olun.",
  "premium.purchaseFailed": "Satın alma işlemi tamamlanamadı. Lütfen tekrar deneyin.",
  "premium.restoreFailed": "Satın alımlarınız geri yüklenemedi. Lütfen tekrar deneyin.",
  "premium.restorePurchase": "Satın alımı geri yükle",
  "premium.savingsPercent": "%{percent} Tasarruf",
  "premium.seePremium": "Premium'u gör",
  "premium.startFreeTrial": "Ücretsiz Denemeyi Başlat",
  "premium.storeUnavailable": "Mağaza şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyin.",
  "premium.subscribeNow": "Şimdi abone ol — deneme süresi yok",
  "premium.switchToPremium": "SmartMixin Premium'a geç",
  "premium.thenPrice": "sonra {price}",
  "providerHints.ambientWeatherApiKey": "ambientweather.net hesap ayarlarınızda oluşturulur.",
  "providerHints.davisApiSecret": "Yalnızca V2 API anahtarını oluşturduğunuzda bir kez gösterilir — güvenli bir yerde saklayın.",
  "providerHints.davisV2ApiKey": "weatherlink.com üzerindeki V2 API anahtarları sayfasından.",
  "providerHints.ecowittApi": "Ecowitt hesabınızın API sayfasından.",
  "providerHints.ecowittApp": "Uygulama anahtarı, yine Ecowitt hesabınızdan.",
  "providerHints.myAcuriteCredentialsBanner": "My AcuRite hesabınızın e-posta ve şifresini kullanın — SmartMixin girişini değil.",
  "providerHints.myAcuriteEmail": "My AcuRite hesabınızın e-postası — SmartMixin girişiniz değil.",
  "providerHints.myAcuritePassword": "My AcuRite hesabınızın şifresi.",
  "providerHints.weatherflowToken": "tempestwx.com → ayarlar → veri yetkilerinden kişisel kullanım belirteci.",
  "providerHints.wundergroundEditKey": "Başka bir anahtar kullan",
  "providerHints.wundergroundKey": "Weather Underground hesabınızın API anahtarları sayfasından alınan uzun bir dizi — wunderground.com şifreniz değil.",
  "providerHints.wundergroundKeyExample": "örn. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API anahtarı doğrulandı",
  "providerHints.wundergroundNoStationsNearby": "Bu konumun yakınında istasyon bulunamadı. Doğrudan bir istasyon kimliği girmeyi deneyin.",
  "providerHints.wundergroundStationIdExample": "örn. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Ambient Weather API anahtarınızı alın.",
  "providerIntro.davisStep2": "Davis V2 API anahtarınızı ve API gizli anahtarınızı alın.",
  "providerIntro.ecowittStep2": "Ecowitt API anahtarı ve Uygulama anahtarınızı alın.",
  "providerIntro.getStarted": "Başlayın",
  "providerIntro.myAcuriteStep2": "Mevcut My AcuRite hesabınızın e-posta ve şifresini kullanın.",
  "providerIntro.netatmoEnergyStep2": "İstendiğinde Netatmo'ya giriş yapın — API anahtarı gerekmez.",
  "providerIntro.netatmoWeatherStep2": "İstendiğinde Netatmo'ya giriş yapın — API anahtarı gerekmez.",
  "providerIntro.signupBanner": "Neredeyse tamam — {provider} bağlantısı kurmak için ücretsiz SmartMixin hesabınızı oluşturun.",
  "providerIntro.step1": "SmartMixin hesabınızda oturum açın ({provider} girişinizde DEĞİL).",
  "providerIntro.step3EmailPassword": "Buraya girin.",
  "providerIntro.step3KeyOrToken": "Buraya yapıştırın.",
  "providerIntro.step3OAuth": "Açılan pencerede SmartMixin'i yetkilendirin.",
  "providerIntro.step3Wunderground": "API anahtarınızı yapıştırın, ardından yakındaki bir istasyonu seçin veya herhangi bir istasyon kimliği girin.",
  "providerIntro.stepOfTotal": "Adım {step}/{total}",
  "providerIntro.title": "{provider} bağlantısı",
  "providerIntro.weatherflowStep2": "Kişisel kullanım Tempest belirtecinizi alın.",
  "providerIntro.wundergroundBrowsePublic": "İstasyonunuz yok mu? Kamuya açık olanlara göz atın",
  "providerIntro.wundergroundFindNearby": "Yakınımdaki istasyonları bul",
  "providerIntro.wundergroundOrEnterId": "Veya bir istasyon kimliği girin",
  "providerIntro.wundergroundStep2": "Weather Underground API anahtarınızı alın. Daha sonra herhangi bir istasyona bağlanabilirsiniz — kendinize ait veya kamuya açık.",
  "reports.agroMeteorology": "Agrometeoroloji",
  "reports.analysis": "Analiz",
  "reports.annualCumulativeRainfallComparison": "Yıllık Kümülatif Yağış Karşılaştırması",
  "reports.annualHeatingDurationComparison": "Yıllık ısıtma süresi karşılaştırması",
  "reports.annualHeatingEfficiency": "Yıllık Isıtma Verimliliği",
  "reports.annualIndoorComparison": "Yıllık İç Mekan Karşılaştırması",
  "reports.annualOutdoorComparison": "Yıllık dış mekan karşılaştırması",
  "reports.annualOutdoorReport": "Yıllık Açık Hava Raporu",
  "reports.annualReport": "Yıllık Rapor",
  "reports.annualSolarReport": "Yıllık Güneş Raporu",
  "reports.annualWaterBalance": "Yıllık Su Dengesi",
  "reports.annualWaterBalanceCarryOver": "{year} yılından devret ({value})",
  "reports.annualWaterBalanceDescription": "Su dengesi (basitleştirilmiş sürüm, yalnızca yağmur ve evapotranspirasyon kullanılır) su kaynağını yönetmeye yardımcı olur",
  "reports.avgHumidity": "Ortalama nem",
  "reports.avgMaxTemperature": "Ortalama T°maks",
  "reports.avgMetric": "Ortalama {metric}",
  "reports.avgMinTemperature": "Ortalama T°min",
  "reports.avgPressure": "Ortalama basınç",
  "reports.avgTemperature": "Ortalama sıcaklık",
  "reports.chartsAndTable": "Grafikler ve tablo",
  "reports.climateNormalPeriodOfRecord": "Ölçüm dönemi ({years} yıl)",
  "reports.climateNormals": "İklim normalleri",
  "reports.climateNormalStandardLabel": "Standart normal ({period})",
  "reports.climateTrendPerDecade": "Sıcaklık eğilimi: on yılda {value} ({years} yıllık dönem)",
  "reports.coldestMonthRanking": "Kayıtlardaki en soğuk {month}",
  "reports.comfortable": "Rahat (%45 {lessThan} nem ≤ %60)",
  "reports.cumulativeRainfall": "Kümülatif yağış",
  "reports.cumulativeRainfallDescription": "Seçilen dönem boyunca biriken toplam yağışı takip edin.",
  "reports.dailyMaxRainfall": "Günlük Max. yağış",
  "reports.dataExport": "Verileri dışa aktar",
  "reports.dataExportXlsxFormatDescription": "İstasyonunuzun tüm verilerini Excel formatında (*.xlsx) dışa aktarın. Düğmeye tıkladıktan sonra, birkaç dakika sonra işlenmiş verilerle bir e-posta alırsınız.",
  "reports.daysOfData": "{days} günlük veri",
  "reports.daysWithFrost": "Donlu günler",
  "reports.daysWithHeavyRain": "Şiddetli yağmurlu günler (≥ {threshold})",
  "reports.daysWithoutThaw": "Çözülme olmayan günler",
  "reports.daysWithStrongFrost": "Güçlü donlu günler",
  "reports.emailSent": "Posta kutunuza bir e-posta gönderildi",
  "reports.frostDays": "Don günü sayısı",
  "reports.grasslandTemperatureSum": "Otlak sıcaklığı toplamı",
  "reports.grasslandTemperatureSumDescription": "İlkbaharda {threshold} toplamı aşılırsa, bitki örtüsünün sürdürülebilir başlangıcına ulaşıldı (Avrupa'da çalışır)",
  "reports.growingDegreeDays": "Büyüme derece günleri",
  "reports.highPressure": "Antisiklon (ortalama basınç ≥ {threshold})",
  "reports.iceDays": "Buzlu günler",
  "reports.indoorReport": "İç mekan raporu",
  "reports.keyFacts": "Anahtar Gerçekler",
  "reports.longestDrySpell": "En uzun kurak dönem",
  "reports.longestRunOfRainyDays": "En uzun yağmurlu gün serisi",
  "reports.longestRunWithoutRun": "Yağmursuz en uzun dönem",
  "reports.longestWetSpell": "En uzun yağışlı dönem",
  "reports.lowPressure": "Düşük basınç (ortalama basınç {lessThan} {threshold})",
  "reports.maxHumidity": "Maksimum nem",
  "reports.maxMetric": "Maksimum {metric}",
  "reports.maxPressure": "Maksimum basınç",
  "reports.maxTemperature": "Maksimum sıcaklık",
  "reports.maxTempGreaterThan": "T°maks ≥",
  "reports.maxTempMagnitude24h": "Maksimum günlük fark (/24 saat)",
  "reports.minHumidity": "Minimum nem",
  "reports.minMetric": "Minimum {metric}",
  "reports.minPressure": "Minimum basınç",
  "reports.minTemperature": "Minimum sıcaklık",
  "reports.minTempMagnitude24h": "Minimum günlük fark (/24 saat)",
  "reports.monthlyAverageCountdown": "Bu ay {days} gün daha",
  "reports.monthlyAverageCountdownDetail": "O zaman bu ayın ortalaması ve sıralaması görünür.",
  "reports.monthlyAverageRule": "Aylık ortalamalar ve sıralamalar, bir takvim ayında {days} gün kaydedildiğinde görünür.",
  "reports.monthlyHeatingEfficiency": "Aylık ısıtma verimliliği",
  "reports.monthlyOutdoorReport": "Aylık dış mekan raporu",
  "reports.monthlyReport": "Aylık Rapor",
  "reports.monthlySolarReport": "Aylık Güneş Raporu",
  "reports.monthlyWindReport": "Aylık Rüzgâr Raporu",
  "reports.monthsOfData": "{months} aylık veri",
  "reports.numberOfDays": "Gün sayısı",
  "reports.onThisDayChartRule": "Yıllara göre grafik, {date} için {count} yıl kaydedildiğinde görünür.",
  "reports.onThisDayChartSummary": "Sıcaklık verisi olan {years, plural, one {# yıl} other {# yıl}}, {first}–{last}. Sıcak rekoru {high} ({highYears}), soğuk rekoru {low} ({lowYear}). Normal gün {min} ile {max} arası.",
  "reports.onThisDayCoverage": "{firstYear} yılından beri {years} yıl",
  "reports.onThisDayDataSince": "Bu istasyonun {date} tarihinden beri verisi var.",
  "reports.onThisDayEveryYear": "Kayıtlardaki her {date}",
  "reports.onThisDayGapNoData": "veri yok",
  "reports.onThisDayInHistory": "Tarihte bugün",
  "reports.onThisDayLeaveOk": "Bu ekrandan çıkabilirsiniz; yükleme devam eder.",
  "reports.onThisDayLoadFailed": "{date} yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.",
  "reports.onThisDayNoDataRun": "{start}–{end} · veri yok ({count} yıl)",
  "reports.onThisDayNormal": "Normal gün: {min} ile {max} arası",
  "reports.onThisDayNoYears": "Henüz eksiksiz bir {date} kaydı yok",
  "reports.onThisDayNoYearsDetail": "Bu sayfa, istasyonun eksiksiz kaydettiği ilk {date} tarihinden itibaren dolar.",
  "reports.onThisDayNoYearSelected": "Yıl seçilmedi",
  "reports.onThisDayOneReading": "1 ölçüm",
  "reports.onThisDayOneReadingSummary": "{year}: {value}, 1 ölçüm, yağmur {rain}",
  "reports.onThisDayOpenRecords": "Rekorlar ve iklim raporunu aç",
  "reports.onThisDayPickHint": "Gösterilen günü değiştirir",
  "reports.onThisDayPickTitle": "Bir gün seçin",
  "reports.onThisDayRain": "{date} tarihinde yağmur",
  "reports.onThisDayRainNotMeasured": "ölçülmedi",
  "reports.onThisDayRainOnlySummary": "{year}: yağmur {rain}",
  "reports.onThisDayRainSince": "{year} yılından beri yağmur",
  "reports.onThisDayRainSummary": "{date} tarihinde yağmur. En yağışlı gün {value} ({years}).",
  "reports.onThisDayRetry": "Tekrar dene",
  "reports.onThisDaySingleReading": "{count} yılda o gün için yalnızca tek bir ölçüm var; bu yıllar çizilmez.",
  "reports.onThisDaySlowLoad": "{date} için {years} yıl okunuyor. Bir tarihe ilk bakış 20 saniyeye kadar sürebilir.",
  "reports.onThisDaySlowLoadGeneric": "Bu istasyonun {date} geçmişi okunuyor. Bir tarihe ilk bakış 20 saniyeye kadar sürebilir.",
  "reports.onThisDayTied": "{years} ile eşit",
  "reports.onThisDayTiedMore": "{years} +{count} ile eşit",
  "reports.onThisDayYearSummary": "{year}: en düşük {min}, en yüksek {max}, yağmur {rain}",
  "reports.onThisDayYearTied": "{year} ({tied})",
  "reports.outdoorReport": "Açık hava raporu",
  "reports.overviewSection": "Genel bakış",
  "reports.rainfall": "Yağış",
  "reports.rainyDays": "Yağmurlu Günler",
  "reports.recordClimatologicalDay": "Klimatolojik gün (06–06 UTC)",
  "reports.recordClimDayBody": "Burada yağış, istasyon saatine göre gece yarısından gece yarısına kadar takvim günü başına toplanır. Meteoroloji servisleri ise 06:00 ile 06:00 UTC arasında toplar; bu nedenle gece yarısı civarındaki bir fırtına başka bir günü en yağışlı gün yapabilir.",
  "reports.recordDailyRain": "En yağışlı gün",
  "reports.recordFromHourlyReadings": "Saatlik ölçümlerden",
  "reports.recordHigh": "Sıcak rekoru",
  "reports.recordLow": "Soğuk rekoru",
  "reports.recordOfficialBody": "Meteoroloji servisi bu istasyon için maksimum ve minimum termometrelerden okunan günlük en yüksek ve en düşük değerleri yayımlar. Bunlar saatlik ölçümlerin kaçırdığı kısa tepeleri yakalar; bu yüzden saatlik ölçümlerden hesaplanan değerlerin yerini alır.",
  "reports.recordOfficialValue": "Resmî değer",
  "reports.recordsAndClimatology": "Rekorlar ve iklim",
  "reports.recordSheetTitle": "Bu rekorlar hakkında",
  "reports.recordsSince": "{date} tarihinden beri rekorlar",
  "reports.recordWindGust": "En güçlü rüzgâr hamlesi",
  "reports.relativelyWet": "Nispeten nemli (%60 {lessThan} nem ≤ %80)",
  "reports.sectionReportCount": "{count} rapor",
  "reports.sendEmail": "E-posta gönder",
  "reports.summerDays": "Yaz günleri",
  "reports.tableScrollRegion": "{title}, yatay olarak kaydırılır",
  "reports.tooDry": "Çok kuru (nem ≤ %45)",
  "reports.tooWet": "Çok nemli (nem {greaterThan} %80)",
  "reports.tropicalNights": "Tropik Geceler",
  "reports.unlockPremiumSubtitle": "SmartMixin Premium’a dahildir",
  "reports.unlockPremiumTitle": "{count} premium özelliğin kilidini aç",
  "reports.warmestMonthRanking": "Kayıtlardaki en sıcak {month}",
  "reports.waterBalance": "Su dengesi",
  "reports.yearsOfData": "{years} yıllık veri",
  "reports.yearToDateTemperatureComparison": "Yıl başından bugüne sıcaklık karşılaştırması",
  "sensors.bgtSensors": "Siyah küre ve WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareHumidity": "Nemi karşılaştır",
  "sensors.compareMoisture": "Toprak nemini karşılaştır",
  "sensors.comparePm25": "PM2.5 karşılaştır",
  "sensors.compareTemperatures": "Sıcaklıkları karşılaştır",
  "sensors.compareWaterTension": "Toprak su gerilimini karşılaştır",
  "sensors.depthByChannel": "Kanala göre derinlik",
  "sensors.heatStressExtreme": "Aşırı ısı stresi",
  "sensors.heatStressModerate": "Orta düzey ısı stresi",
  "sensors.heatStressNone": "Isı stresi yok",
  "sensors.heatStressStrong": "Güçlü ısı stresi",
  "sensors.heatStressVeryStrong": "Çok güçlü ısı stresi",
  "sensors.indoorClimate": "İç ortam iklimi",
  "sensors.indoorCo2Levels": "CO2 seviyeleri",
  "sensors.indoorTemperatureAndHumidity": "Sıcaklık ve nem",
  "sensors.leafWetnessByChannel": "Kanala göre yaprak nemi",
  "sensors.lightningSensor": "Yıldırım",
  "sensors.moistureByChannel": "Kanala göre toprak nemi",
  "sensors.noDataAvailable": "Veri mevcut değil",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "Kanala göre PM2.5",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Kanal seçin",
  "sensors.sensorDetailDescription": "Sensör kanallarınızın geçmiş verilerini ve eğilimlerini görüntüleyin.",
  "sensors.sensorHistory": "Sensör geçmişi",
  "sensors.soilConductivityByChannel": "Kanala göre iletkenlik",
  "sensors.soilTemperatureByChannel": "Kanala göre toprak sıcaklığı",
  "sensors.strikesToday": "Bugün düşen yıldırım",
  "sensors.temperatureByChannel": "Kanala göre sıcaklık",
  "sensors.viewChart": "Grafiği görüntüle",
  "sensors.waterTensionByChannel": "Kanala göre toprak su gerilimi",
  "settings.appearance": "Görünüm",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Arapça",
  "settings.bulgarian": "Bulgarca",
  "settings.catalan": "Katalanca",
  "settings.chartGestures": "Grafiklerde jestler",
  "settings.chartGesturesDescription": "Grafiklerde kaydırma zaman aralığını, iki parmakla sıkıştırma ise zaman ölçeğini değiştirir",
  "settings.choiceCount": "{count, plural, one {# kullanılabilir} other {# kullanılabilir}}",
  "settings.contactUs": "Bize ulaşın",
  "settings.contactUsDescription": "Yardım alın veya geri bildirim gönderin",
  "settings.croatian": "Hırvatça",
  "settings.czech": "Çekçe",
  "settings.dailyDetailByPeriods": "Dönemlere göre günlük ayrıntı",
  "settings.dailyDetailByPeriodsDescription": "24 saati gece, sabah, öğleden sonra ve akşam olarak gruplar — günlük özetin kullandığı bölümlemenin aynısı.",
  "settings.danish": "Danca",
  "settings.dark": "Koyu tema",
  "settings.dataDisplay": "Veri görüntüleme",
  "settings.dateAndTime": "Tarih ve saat",
  "settings.donateButton": "Bağış yapın",
  "settings.donateDescription": "SmartMixin küçük bir ekip tarafından geliştiriliyor. Faydalı buluyorsanız, dilediğiniz tutarda tek seferlik bir bağışla gelişimine destek olabilirsiniz. Bu bir hediyedir — planınızı değiştirmez ve herhangi bir özelliği açmaz.",
  "settings.donateSuccessBody": "Bağışınız, SmartMixin'in çalışmaya ve gelişmeye devam etmesine yardımcı olur. İçtenlikle minnettarız.",
  "settings.donateSuccessTitle": "Desteğiniz için teşekkürler!",
  "settings.donateTitle": "SmartMixin'e destek olun",
  "settings.dragToReorder": "Yeniden sıralamak için sürükleyin",
  "settings.dutch": "Flemenkçe",
  "settings.english": "İngilizce",
  "settings.french": "Fransızca",
  "settings.german": "Almanca",
  "settings.gestures": "Jestler",
  "settings.greek": "Yunanca",
  "settings.hungarian": "Macarca",
  "settings.italian": "İtalyanca",
  "settings.japanese": "Japonca",
  "settings.korean": "Korece",
  "settings.language": "Dil",
  "settings.languageDescription": "Tercih edilen dil",
  "settings.light": "Açık tema",
  "settings.mapTheme": "Harita teması",
  "settings.mapThemeAuto": "Otomatik",
  "settings.mapThemeDark": "Koyu",
  "settings.mapThemeDescription": "Otomatik seçildiğinde harita, uygulamanın temasına uyar.",
  "settings.mapThemeLight": "Açık",
  "settings.measurementUnits": "Ölçü birimleri",
  "settings.netatmoDashboard": "Netatmo panosu",
  "settings.netatmoLayoutCards": "Kart listesi",
  "settings.netatmoLayoutCardsDescription": "Her modül için bir kart, tek kaydırmada",
  "settings.netatmoLayoutClassic": "Klasik",
  "settings.netatmoLayoutClassicDescription": "İki kart, modüller arasında geçiş",
  "settings.netatmoNewLayoutNotice": "Yeni pano düzeni: her modül için bir kart.",
  "settings.netatmoSwitchBackToClassic": "Klasiğe dön",
  "settings.netatmoSwitchToLayout": "{layout} görünümüne geç",
  "settings.norwegian": "Norveççe",
  "settings.notificationsSection": "Bildirimler",
  "settings.ongoingNotificationEnabled": "Kalıcı bildirimi etkinleştir",
  "settings.ongoingNotificationMetrics": "Gösterilen ölçümler",
  "settings.ongoingNotificationPermissionRequired": "Bildirim izni gerekli",
  "settings.ongoingNotificationPreviewHint": "Önizleme — göstermek için widget'ı açın",
  "settings.ongoingNotificationStatusBar": "Durum çubuğu",
  "settings.polish": "Lehçe",
  "settings.portuguese": "Portekizce",
  "settings.preferencesSection": "Tercihler",
  "settings.privacyPolicy": "Gizlilik Politikası",
  "settings.russian": "Rusça",
  "settings.serbian": "Sırpça",
  "settings.settings": "Ayarlar",
  "settings.settingsPageTitle": "Ayarlar - {page}",
  "settings.slovak": "Slovakça",
  "settings.smallDecimals": "Küçük ondalıklar",
  "settings.smallDecimalsDescription": "Ondalık basamakları daha küçük boyutta göster",
  "settings.spanish": "İspanyolca",
  "settings.statusBarWidget": "Durum çubuğu widget'ı",
  "settings.statusBarWidgetDescription": "Her zaman görünür hava verileri",
  "settings.subscriptionSection": "Abonelik",
  "settings.supportSection": "Destek",
  "settings.swedish": "İsveççe",
  "settings.systemTheme": "Sistem teması",
  "settings.termsOfService": "Hizmet Şartları",
  "settings.themeDarkShort": "Koyu",
  "settings.themeLightShort": "Açık",
  "settings.themeSystemShort": "Sistem",
  "settings.turkish": "Türkçe",
  "settings.ukrainian": "Ukraynaca",
  "settings.units": "Birimler",
  "settings.unitsDescription": "Uygulamada görüntülenen ölçüm birimleri",
  "settings.update": "Güncelle",
  "settings.windDirectionConvention": "Rüzgâr yönü oku",
  "settings.windDirectionConventionDescription": "Rüzgâr yönü oklarının nasıl görüntüleneceğini seçin",
  "settings.windDirectionMeteorological": "Kaynak yönü",
  "settings.windDirectionMeteorologicalDescription": "Ok, rüzgârın nereden geldiğini gösterir (meteorolojik uzlaşım)",
  "settings.windDirectionOceanographic": "Akış yönü",
  "settings.windDirectionOceanographicDescription": "Ok, rüzgârın nereye estiğini gösterir (oşinografik uzlaşım)",
  "stations.addAStation": "Bir İstasyon Ekle",
  "stations.addToFavorites": "Favorilere ekle",
  "stations.addYourOwnStation": "Kendi istasyonunuzu ekleyin",
  "stations.clearRecentLocations": "Tümünü temizle",
  "stations.clearSearch": "Aramayı temizle",
  "stations.currentLocation": "Mevcut Konum",
  "stations.customizedStationName": "Özelleştirilmiş İstasyon Adı",
  "stations.favoriteLocations": "Favoriler",
  "stations.favoriteLocationsEmpty": "En fazla 5 favori yer ekleyebilirsiniz.",
  "stations.favoriteStations": "Favori İstasyonlar",
  "stations.filterStationDescription": "Güvenilmez ölçümlere sahip istasyonları gösterme",
  "stations.filterStations": "İstasyonları filtrele",
  "stations.filterStationSourceDescription": "Haritada görüntülemek istediğiniz istasyon sağlayıcılarını seçin",
  "stations.findStationsNearYou": "Yakınınızdaki istasyonları bulun",
  "stations.hiddenStations": "Gizli İstasyonlar",
  "stations.hiddenStationsDescription": "Yanındaki göz simgesine dokunarak bir istasyonu tekrar gösterebilirsiniz.",
  "stations.hideStationNamed": "Gizle: {station}",
  "stations.lastSeen": "son görülme {time}",
  "stations.loadingStation": "İstasyon yükleniyor…",
  "stations.location": "Konum",
  "stations.locationAddedToFavorites": "Favorilere yer eklendi",
  "stations.locationNotGranted": "Konum izni verilmedi. Lütfen cihaz ayarlarından konumunuza erişime izin verin.",
  "stations.locationRemovedFromFavorites": "Konum favorilerden kaldırıldı",
  "stations.locations": "Yerler",
  "stations.locationUnavailable": "Konumunuz alınamadı. Lütfen cihaz ayarlarınızı kontrol edin.",
  "stations.maxFavoriteLocationsReached": "Sadece en fazla 5 favori yere sahip olabilirsiniz. Birini eklemek için bir tane çıkarın.",
  "stations.modifyFavoriteStations": "Favori istasyonları değiştirin",
  "stations.modifyFavoriteStationsDescription": "En sevdiğiniz istasyonları sürükleyerek yeniden sıralayabilirsiniz. Bunları listeden de kaldırabilirsiniz.",
  "stations.myLocation": "Konumum",
  "stations.nearbyWeatherStations": "Yakın hava istasyonları",
  "stations.noLocationsFound": "Konum bulunamadı",
  "stations.noLongerReported": "Artık listede değil",
  "stations.noLongerReportedBy": "{provider}: {date} tarihinden beri listede değil",
  "stations.noSearchResults": "Aramanızla eşleşen makale yok",
  "stations.noStationsFound": "İstasyon bulunamadı",
  "stations.noWeatherStationYet": "Henüz bir hava istasyonunuz yok.",
  "stations.recentLocations": "Son kullanılanlar",
  "stations.recentLocationsEmpty": "Geçmişiniz boş.",
  "stations.removeFromFavorites": "Favorilerden kaldır",
  "stations.removeStationNamed": "Favorilerden kaldır: {station}",
  "stations.reorderStationNamed": "Taşı: {station}",
  "stations.searchForLocation": "Bir konum arayın",
  "stations.searchForWeatherStation": "Hava istasyonu arayın",
  "stations.searchResults": "Arama Sonuçları",
  "stations.searchResultsEmpty": "Sonuç bulunamadı.",
  "stations.searchResultsFound": "{count, plural, one {# sonuç bulundu} other {# sonuç bulundu}}",
  "stations.searchStationsDescription": "Yakındaki hava istasyonlarını bulmak için bir şehir, adres veya yer adı girin.",
  "stations.searchStationsHint": "Dünyanın herhangi bir yerindeki hava istasyonlarını keşfetmek için yukarıdaki arama çubuğunu kullanın.",
  "stations.selectStationForComparison": "Karşılaştırmak için bir istasyon seçin",
  "stations.stationAddedToFavorites": "Sık kullanılanlara istasyon eklendi",
  "stations.stationCount": "{count, plural, one {# istasyon} other {# istasyon}}",
  "stations.stationInformation": "İstasyon bilgileri",
  "stations.stationName": "İstasyon adı",
  "stations.stationObservationsDescription": "Hava istasyonlarından en son gözlemleri görüntüleyin",
  "stations.stationRemovedFromFavorites": "İstasyon favorilerden kaldırıldı",
  "stations.stationsLoading": "Hava istasyonları yükleniyor",
  "stations.stationsNear": "{place} yakınındaki istasyonlar",
  "stations.stationType": "İstasyon tipi",
  "stations.statusOffline": "Çevrimdışı",
  "stations.statusOnline": "Çevrimiçi",
  "stations.statusStale": "Eski",
  "stations.tryAnotherLocation": "Bu konumun yakınında hava istasyonu bulamadık. Farklı bir bölgede aramayı deneyin.",
  "stations.unhideStationNamed": "Tekrar göster: {station}",
  "stations.weatherStation": "Hava istasyonu",
  "stations.weatherStationCount": "{count, plural, one {# hava istasyonu} other {# hava istasyonu}}",
  "stations.weatherStations": "Hava istasyonları",
  "stations.welcomeConnectService": "Hava durumu istasyonunuz var mı? Servisinizi bağlayın",
  "stations.welcomeSubtitle": "Hava durumunuz, hepsi tek bir yerde",
  "thermostat.away": "Dışarıda",
  "thermostat.boilerOn": "Kazan",
  "thermostat.hg": "Donma koruması",
  "thermostat.homeInformation": "Ev bilgileri",
  "thermostat.homeName": "Ev adı",
  "thermostat.manualBoost": "Manuel artırma",
  "thermostat.manualSetpointUntil": "Manuel ayar bitişi",
  "thermostat.noThermostatYet": "Henüz termostatınız yok.",
  "thermostat.relay": "Röle",
  "thermostat.room": "Oda",
  "thermostat.rooms": "Odalar",
  "thermostat.smartThermostat": "Akıllı termostat",
  "thermostat.smartValve": "Akıllı valf",
  "thermostat.whenBackHome": "Ne zaman eve döneceksiniz?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "İnç",
  "units.inchOfMercury": "İnç cıva",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Saatte kilometre",
  "units.knot": "Knot",
  "units.meterPerSecond": "Saniyede metre",
  "units.milePerHour": "Saatte mil",
  "units.millibar": "Milibar",
  "units.millimeter": "Milimetre",
  "units.millimeterOfMercury": "Milimetre cıva",
  "weatherConditions.blizzard": "Kar fırtınası",
  "weatherConditions.blowingDust": "Savrulan toz",
  "weatherConditions.blowingSnow": "Savrulan kar",
  "weatherConditions.breezy": "Hafif rüzgâr",
  "weatherConditions.clear": "Açık",
  "weatherConditions.cloudy": "Bulutlu",
  "weatherConditions.drizzle": "Çiseleme",
  "weatherConditions.flurries": "Hafif kar",
  "weatherConditions.foggy": "Sis",
  "weatherConditions.freezingDrizzle": "Dondurucu çiseleme",
  "weatherConditions.freezingRain": "Dondurucu yağmur",
  "weatherConditions.frigid": "Şiddetli soğuk",
  "weatherConditions.hail": "Dolu",
  "weatherConditions.haze": "Pus",
  "weatherConditions.heavyRain": "Şiddetli yağmur",
  "weatherConditions.heavySnow": "Yoğun kar yağışı",
  "weatherConditions.hot": "Sıcak",
  "weatherConditions.hurricane": "Kasırga",
  "weatherConditions.isolatedThunderstorms": "İzole gök gürültülü sağanaklar",
  "weatherConditions.mixedRainAndHail": "Yağmur ve dolu",
  "weatherConditions.mostlyClear": "Çoğunlukla açık",
  "weatherConditions.mostlyCloudy": "Çoğunlukla bulutlu",
  "weatherConditions.mostlySunny": "Çoğunlukla güneşli",
  "weatherConditions.notAvailable": "Hava durumu bilgisi mevcut değil",
  "weatherConditions.partlyCloudy": "Parçalı bulutlu",
  "weatherConditions.rain": "Yağmur",
  "weatherConditions.rainSleet": "Yağmur ve buz taneleri",
  "weatherConditions.rainSnow": "Karla karışık yağmur",
  "weatherConditions.scatteredShowers": "Yer yer sağanak yağış",
  "weatherConditions.scatteredSnowShowers": "Yer yer kar sağanağı",
  "weatherConditions.scatteredThunderstorms": "Yer yer gök gürültülü sağanak",
  "weatherConditions.showers": "Sağanak yağış",
  "weatherConditions.sleet": "Buz taneleri",
  "weatherConditions.smoke": "Duman",
  "weatherConditions.snow": "Kar",
  "weatherConditions.snowShowers": "Kar sağanağı",
  "weatherConditions.strongStorms": "Şiddetli gök gürültülü fırtına",
  "weatherConditions.sunny": "Güneşli",
  "weatherConditions.thunderstorms": "Gök gürültülü sağanak yağış",
  "weatherConditions.tornado": "Hortum",
  "weatherConditions.tropicalStorm": "Tropikal fırtına",
  "weatherConditions.windy": "Rüzgârlı",
  "weatherConditions.wintryMix": "Karışık kış yağışı",
  "weatherMap.clusterMarkerName": "{metric} {value}, {count, plural, other {# istasyonun}} medyanı, yakınlaştır",
  "weatherMap.legendHeavy": "Yoğun",
  "weatherMap.legendLight": "Hafif",
  "weatherMap.legendLightningHelp": "Renk, son {minutes} dakikadaki her yıldırımın yaşını gösterir — en yeniler beyaz, en eskiler koyu kırmızı.",
  "weatherMap.legendNewest": "En yeni",
  "weatherMap.legendOldest": "En eski",
  "weatherMap.legendStationsHelp": "İşaretçi rengi seçili ölçümün değerini yansıtır.",
  "weatherMap.lightningDataAttribution": "Yıldırım verileri: Blitzortung.org",
  "weatherMap.lightningStrikes": "Yıldırım düşmeleri",
  "weatherMap.lightningStrikesDescription": "Yıldırım düşmelerini haritada gerçek zamanlı göster",
  "weatherMap.mapLayers": "Harita katmanları",
  "weatherMap.mapLegend": "Harita göstergesi",
  "weatherMap.mapMode": "Harita modu",
  "weatherMap.mapNameForecast": "Tahmin haritası, {model}, {variable}",
  "weatherMap.mapNameObservations": "Hava haritası, gözlemler",
  "weatherMap.modeForecast": "Tahmin",
  "weatherMap.modeObservations": "Gözlemler",
  "weatherMap.radarDataAttribution": "Radar verileri: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.radarTime": "Radar zamanı",
  "weatherMap.rainRadar": "Yağmur radarı",
  "weatherMap.rainRadarDescription": "Haritada yağmur radar kaplamasını göster",
  "weatherMap.resetBearing": "Haritayı döndürmek için sürükleyin, kuzeye yeniden yönlendirmek için tıklayın",
  "weatherMap.showingForecast": "Gösterilen tahmin: {model}, {variable}",
  "weatherMap.signInForecastBody": "GFS haritaları bir SmartMixin hesabıyla ücretsizdir. Premium ile daha fazla modele erişebilirsiniz.",
  "weatherMap.signInForecastTitle": "Tahmin haritalarını görmek için giriş yapın",
  "weatherMap.stationMarkerName": "{metric} {value}, tek istasyon",
  "weatherMap.stationMarkersHint": "Ok tuşlarıyla istasyonlar arasında geçiş yapılır",
  "weatherMap.stationMarkerWindValue": "{speed}, {direction} yönünden",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain, Nearcast teknolojisiyle desteklenen Tempest Weather System aracılığıyla sağlanan ek bir veri kaynağıdır. NC Rain verileri, Tempest cihazınızın çevresindeki ortalama yağış birikiminin mahalle düzeyinde bir tahminidir.",
  "weatherMap.weatherMap": "Hava haritası",
  "weatherMap.weatherMapMetaDescription": "SmartMixin, dünya genelinde hava koşulları için etkileşimli hava durumu ve radar haritaları sunar.",
  "weatherMap.zoomIn": "Yakınlaştır",
  "weatherMap.zoomOut": "Uzaklaştır",
  "weatherWarnings.activeNow": "Şu anda geçerli",
  "weatherWarnings.agencyMessage": "Meteoroloji servisinin mesajı",
  "weatherWarnings.areaCovered": "Etkilenen bölge",
  "weatherWarnings.areaThisLocation": "{area} (bu konum)",
  "weatherWarnings.areaYourStation": "{area} (hava istasyonunuz)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Resmî uyarı, {severity}: {hazard}} one {Resmî uyarı, {severity}: {hazard}, ve # tane daha} other {Resmî uyarı, {severity}: {hazard}, ve # tane daha}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Yaklaşan resmî uyarı, {severity}: {hazard}} one {Yaklaşan resmî uyarı, {severity}: {hazard}, ve # tane daha} other {Yaklaşan resmî uyarı, {severity}: {hazard}, ve # tane daha}}",
  "weatherWarnings.crumb": "Resmî uyarılar",
  "weatherWarnings.emptyBody": "Ulusal meteoroloji servisinin bu yer için yürürlükte bir uyarısı yok. Birkaç dakikada bir yeniden kontrol ediyoruz.",
  "weatherWarnings.emptyTitle": "Resmî uyarı yok",
  "weatherWarnings.ended": "Sona erdi",
  "weatherWarnings.endedAt": "Bu uyarı sona erdi: {time}.",
  "weatherWarnings.errorBody": "Bağlantınızı kontrol edin. Birkaç dakikada bir yeniden deniyoruz.",
  "weatherWarnings.errorTitle": "Resmî uyarılar yüklenemedi",
  "weatherWarnings.fromTime": "Başlangıç: {time}",
  "weatherWarnings.hazardAirQuality": "Hava kalitesi",
  "weatherWarnings.hazardAvalanche": "Çığ",
  "weatherWarnings.hazardCoastalEvent": "Kıyı tehlikeleri",
  "weatherWarnings.hazardFlood": "Sel ve taşkın",
  "weatherWarnings.hazardFog": "Sis",
  "weatherWarnings.hazardForestFire": "Orman yangınları",
  "weatherWarnings.hazardHighTemperature": "Yüksek sıcaklık",
  "weatherWarnings.hazardLowTemperature": "Düşük sıcaklık",
  "weatherWarnings.hazardOther": "Diğer tehlike",
  "weatherWarnings.hazardRain": "Yağmur",
  "weatherWarnings.hazardSnowIce": "Kar ve buzlanma",
  "weatherWarnings.hazardThunderstorm": "Gök gürültülü sağanak yağış",
  "weatherWarnings.hazardUv": "UV ışınımı",
  "weatherWarnings.hazardWind": "Rüzgâr",
  "weatherWarnings.hideHazards": "Tehlikeleri gizle",
  "weatherWarnings.issuedBy": "Yayımlayan: {sender}",
  "weatherWarnings.lastUpdate": "Son güncelleme: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Etkilenen bölgenin haritası: {area}.} other {Etkilenen # bölgenin haritası. {area} vurgulanmıştır.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Etkilenen bölgenin haritası.} other {Etkilenen # bölgenin haritası.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Harita kullanılamıyor. Bölge aşağıda listelenmiştir.} other {Harita kullanılamıyor. # bölge aşağıda listelenmiştir.}}",
  "weatherWarnings.moreHazards": "+ {count} tane daha: {hazards}",
  "weatherWarnings.notInLanguage": "{language} dilinde mevcut değil. Meteoroloji servisinin yayımladığı haliyle gösteriliyor.",
  "weatherWarnings.openOn": "{site} sitesinde aç",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # bölge daha} other {+ # bölge daha}}",
  "weatherWarnings.severityExtreme": "Aşırı",
  "weatherWarnings.severityFrom": "{severity}, başlangıç: {time}",
  "weatherWarnings.severityMinor": "Düşük",
  "weatherWarnings.severityModerate": "Orta",
  "weatherWarnings.severityNow": "{severity}, şu anda",
  "weatherWarnings.severitySevere": "Ciddi",
  "weatherWarnings.severityUntil": "{severity}, bitiş: {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {# bölgeyi göster} other {# bölgenin tümünü göster}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {# bölgeyi haritada göster} other {# bölgenin tümünü haritada göster}}",
  "weatherWarnings.showHazards": "Tehlikeleri göster",
  "weatherWarnings.showPeriods": "{count, plural, one {# dönemi göster} other {# dönemin tümünü göster}}",
  "weatherWarnings.source": "Kaynak: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, ardından {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# resmî hava uyarısı} other {# resmî hava uyarısı}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Resmî hava uyarıları",
  "weatherWarnings.todayAt": "bugün {time}",
  "weatherWarnings.tomorrow": "Yarın",
  "weatherWarnings.tomorrowAt": "yarın {time}",
  "weatherWarnings.upcoming": "Yaklaşan",
  "weatherWarnings.viewAll": "Tüm resmî uyarılar",
  "weatherWarnings.whatToDo": "Ne yapmalı"
}
